<main id="main" class="main">
  <section class="section dashboard">
    <div class="row">
      <div class="col-sm-10">
        <!-- Main Corporate Details Form -->
        <div class="row">
          <div class="col-sm-12">
            <form class="onbordingform form-container linescrollbar" [formGroup]="brokerregform">
              <!-- <fieldset disabled="disabled" id="fieldsetattr"> -->
              <div class="row">
                <div class="form-group col-12">
                  <h6 class="admintitle">

                    <span class="bartitlelabel">{{lang.Advisor_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i></span>
                  </h6>
                </div>
              </div>
              <div class="row mb-2">
                <div class="form-group col-md-6">
                  <label for="Corporation" class="Corporation">{{lang.Select_commission_based_type_of_broker_account}}</label>
                  <div class="d-flex">
                    <div class="form-check form-check-inline d-flex">
                      <input type="radio" name="brokerShare" id="brokerShareno" value="false"
                        formControlName="brokerShare" (change)="soleBroker($event)" />
                      <label for="brokerShareno" class="brokerShare my-auto">&nbsp;&nbsp;{{lang.Sole}}</label>
                    </div>
                    <div class="form-check form-check-inline d-flex ">
                      <input type="radio" name="brokerShare" id="brokerShareyes" value="true"
                        formControlName="brokerShare" (change)="soleBroker($event)" />
                      <label for="brokerShareyes" class="brokerShare my-auto">&nbsp;&nbsp;{{lang.Shared}}</label>
                    </div>

                  </div>



                  <div *ngIf="
                      broker['brokerShare'].touched &&
                      broker['brokerShare'].invalid
                    " class="help-block text-danger">
                    <div *ngIf="
                        broker['brokerShare'].errors &&
                        broker['brokerShare'].errors['required']
                      ">
                      {{lang.Please_select_brokershare}}
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="form-group col-4" *ngIf="noofbrokerscount">
                  <label for="Corporation" class="Corporation">{{lang.Brokers_involved_in_shared_account}}</label>



                  <select class="form-control select2" id="parentidrole" placeholder="Select"
                    formControlName="brokerCount" data-live-search="true" (change)="getbrookercount($event)">

                    <option value="" label="" disabled>{{lang.Select}}</option>
                    <option value="2" label="">2</option>
                    <option value="3" label="">3</option>
                    <option value="4" label="">4</option>
                    <option value="5" label="">5</option>
                  </select>
                  <div *ngIf="
                  broker['brokerCount'].touched &&
                  broker['brokerCount'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    broker['brokerCount'].errors &&
                    broker['brokerCount'].errors['required']
                  ">
                      {{lang.Please_select_no_of_brokers}}
                    </div>
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="form-group col-2" style="margin-top:23px" *ngIf="showSharedBrokerList">
                  <button type="button" data-bs-target="#childInfoModal" style="border-radius:5px"
                    class="btn btn-primary" (click)="brokerAdd()">{{lang.Add}}</button>
                </div>
              </div>

              <div *ngIf="showsoleAdvisorData">
                <div class="input-wrapper row" >
                  <div class="form-group col-md-6" *ngIf="allBrokers && allBrokers.length > 0">
                    <label for="Corporation" class="Corporation">{{lang.Brokerage_Parent_Advisor}}</label>

                    <select class="form-control select2" id="parentidrole" placeholder="Select"
                      formControlName="ParentbrokerName" data-live-search="true" (change)="getBrokerlistData($event)">
                      <option value="" label="" disabled>{{lang.Select}}</option>
                      <option *ngFor="let broker of allBrokersUnique" [value]="broker.id">
                        <!-- {{ broker.fullName }} -->
                        {{ broker.name }}-{{ broker.brokerType }}-{{
                          broker.salesTrackingCode
                          }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                        <!-- {{broker.salesTrackingCodeWithStatement}} -->
                      </option>
                    </select>
                    <div *ngIf="
                    broker['ParentbrokerName'].touched &&
                    broker['ParentbrokerName'].invalid
                  " class="help-block text-danger">
                    <div *ngIf="
                      broker['ParentbrokerName'].errors &&
                      broker['ParentbrokerName'].errors['required']
                    ">
                      Please select Brokerage / Parent Advisor
                    </div>
                  </div>
                    <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
                  <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
                </div> -->
                  </div>
                  <div class="form-group col-md-6">
                    <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>
                    <!-- <select
                  class="form-control"
                  id="brokerType"
                  placeholder="Select"
                  formControlName="brokerType">
                  <option value="">Select</option>
                  <option value="ADVISOR">Advisor</option>
                  <option value="ASSOCIATION">Association</option>
                  <option value="BROKERAGE">Brokerage</option>
                  <option value="TPA/MGA">TPA/MGA</option>
                  </select> -->

                    <select class="form-control" id="brokerType" placeholder="Select"
                      (change)="checkbrokertype(brokername.value)" #brokername formControlName="brokerType">
                      <option value="">{{lang.Select}}</option>

                      <option *ngFor="let name of brokerType" [value]="name.label">
                        {{ name.display }}
                      </option>
                    </select>
                    <div *ngIf="
                      broker['brokerType'].touched &&
                      broker['brokerType'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['brokerType'].errors &&
                        broker['brokerType'].errors['required']
                      ">
                        {{lang.Please_select_role}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="input-wrapper row">
                  <div class="form-group col-md-6">
                    <label for="Corporation" class="Corporation">{{lang.Name_of_Broker}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="nameofcorporation"
                      placeholder={{lang.Name_of_Broker}} style="text-transform: capitalize" formControlName="brokersName"
                      (change)="checkAdvsiorNameExist()" />
                    <div *ngIf="
                      broker['brokersName'].touched &&
                      broker['brokersName'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['brokersName'].errors &&
                        broker['brokersName'].errors['required']
                      ">
                        {{lang.Please_enter_broker_name}}
                      </div>
                      <div *ngIf="
                        broker['brokersName'].errors &&
                        broker['brokersName'].errors['minlength']
                      ">
                        <!-- {{lang.Broker_name_must_be_atleast_3_characters}} -->
                         Broker Name must be minimum of 1 character
                      </div>
                      <div *ngIf="
                        broker['brokersName'].errors &&
                        broker['brokersName'].errors['maxlength']
                      ">
                        {{lang.Broker_name_must_not_exceed_255_characters}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-6" *ngIf="showBusinessnumber">
                    <label for="Corporation" class="Corporation">{{lang.Business_Number}}<span
                        style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="businessnumber"
                      placeholder={{lang.Business_Number}} formControlName="businessnumber" />
                    <div *ngIf="
                      broker['businessnumber'].touched &&
                      broker['businessnumber'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['businessnumber'].errors &&
                        broker['businessnumber'].errors['required']
                      ">
                        {{lang.Please_enter_business_number}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Phone}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="primaryPhone"
                      (change)="phoneFormat('primaryPhone')" placeholder={{lang.Phone}} formControlName="primaryPhone"
                      (keypress)="numberOnly($event)" />
                    <div *ngIf="
                      broker['primaryPhone'].touched &&
                      broker['primaryPhone'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['primaryPhone'].errors &&
                        broker['primaryPhone'].errors['required']
                      ">
                        {{lang.Please_enter_phone_number}}
                      </div>
                      <div *ngIf="
                        broker['primaryPhone'].errors &&
                        broker['primaryPhone'].errors['minlength']
                      ">
                        {{lang.Phone_number_minimum_of_10_digits}}
                      </div>
                      <div *ngIf="
                        broker['primaryPhone'].errors &&
                        broker['primaryPhone'].errors['maxlength']
                      ">
                        {{lang.Phone_number_maximum_of_10_digits}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Secondary_Phone}}</label>

                    <input type="text" class="form-control checking-field" (change)="phoneFormat('secondaryPhone')"
                      id="secondaryPhone" placeholder={{lang.Secondary_Phone}} formControlName="secondaryPhone"
                      (keypress)="numberOnly($event)" />
                    <div *ngIf="
                      broker['secondaryPhone'].touched &&
                      broker['secondaryPhone'].invalid
                    " class="help-block text-danger">
                      <!-- <div *ngIf="broker['primaryPhone'].errors && broker['primaryPhone'].errors['required']">Please enter Phone number</div> -->
                      <div *ngIf="
                        broker['secondaryPhone'].errors &&
                        broker['secondaryPhone'].errors['minlength']
                      ">
                        {{lang.Phone_number_minimum_of_10_digits}}
                      </div>
                      <div *ngIf="
                        broker['secondaryPhone'].errors &&
                        broker['secondaryPhone'].errors['maxlength']
                      ">
                        {{lang.Phone_number_maximum_of_10_digits}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>
                    <!-- <input
                  type="text"
                  class="form-control checking-field"
                  id="email"
                  placeholder="Primary Email"
                  formControlName="primaryEmail"
                  (keypress)="checkEmailValidation($event)"/> -->

                    <input type="text" class="form-control checking-field" type="text" id="email"
                      placeholder={{lang.Email}} formControlName="primaryEmail"
                      (keypress)="textChangeToLowerCase('primaryEmail')" />

                    <div *ngIf="
                      broker['primaryEmail'].touched &&
                      broker['primaryEmail'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['primaryEmail'].errors &&
                        broker['primaryEmail'].errors['required']
                      ">
                        {{lang.Please_enter_email}}
                      </div>
                      <div *ngIf="
                        broker['primaryEmail'].errors &&
                        (broker['primaryEmail'].errors['pattern'] ||
                          broker['primaryEmail'].errors['invalidEmail'])
                      ">
                        {{lang.Please_enter_valid_email}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Secondary_Email}}</label>

                    <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Secondary_Email}}
                      formControlName="secondaryEmail" (keypress)="textChangeToLowerCase('secondaryEmail')" />

                    <div *ngIf="
                      broker['secondaryEmail'].touched &&
                      broker['secondaryEmail'].invalid
                    " class="help-block text-danger">
                      <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                      <div *ngIf="
                        broker['secondaryEmail'].errors &&
                        broker['secondaryEmail'].errors['pattern']
                      ">
                      {{lang.Please_enter_valid_email}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Third_Email}}</label>

                    <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Third_Email}}
                      formControlName="thirdEmail" (keypress)="textChangeToLowerCase('thirdEmail')" />

                    <div *ngIf="
                      broker['thirdEmail'].touched &&
                      broker['thirdEmail'].invalid
                    " class="help-block text-danger">
                      <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                      <div *ngIf="
                        broker['thirdEmail'].errors &&
                        broker['thirdEmail'].errors['pattern']
                      ">
                        {{lang.Please_enter_valid_email}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="Street Address"
                      placeholder={{lang.Street_Address}} formControlName="streetAddress" />
                    <div *ngIf="
                      broker['streetAddress'].touched &&
                      broker['streetAddress'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['streetAddress'].errors &&
                        broker['streetAddress'].errors['required']
                      ">
                        {{lang.Please_enter_street_address_name}}
                      </div>
                    </div>
                  </div>
                  <div class="form-group col-md-4">
                    <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}}</label>

                    <input type="text" class="form-control checking-field" id="StreetAddreess2"
                      placeholder={{lang.Street_Address_Line_2}} formControlName="streetAddress2" />
                  </div>
                </div>

                <div class="row">
                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="city" placeholder={{lang.City}}
                      style="text-transform: capitalize" formControlName="city" />
                    <!-- (keypress)="alphaNumarics($event)" -->
                    <div *ngIf="broker['city'].touched && broker['city'].invalid" class="help-block text-danger">
                      <div *ngIf="
                        broker['city'].errors &&
                        broker['city'].errors['required']
                      ">
                        {{lang.Please_enter_city_name}}
                      </div>
                      <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                  <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                    </div>
                  </div>

                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                    <select class="form-control" id="country" placeholder="Country" formControlName="country">
                      <option value="">{{lang.Select}}</option>
                      <option value="canada" selected>Canada</option>
                      <!-- <option value="usa">USA</option> -->

                      <!-- <option
                    *ngFor="let name of configprovinceres"
                    [value]="name.shortName"
                  >
                    {{ name.shortName }}
                  </option> -->
                    </select>
                    <div *ngIf="
                      broker['country'].touched && broker['country'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['country'].errors &&
                        broker['country'].errors['required']
                      ">
                        {{lang.Please_select_country}}
                      </div>
                      <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                  <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                    </div>
                  </div>

                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

                    <select class="form-control" id="Province" placeholder={{lang.Province}} formControlName="Province"
                      (change)="provincelist($event)">
                      <option value="">{{lang.Select}}</option>

                      <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                        {{ name.shortName }}
                      </option>
                    </select>

                    <div *ngIf="
                      broker['Province'].touched && broker['Province'].invalid
                    " class="help-block text-danger">
                      <div *ngIf="
                        broker['Province'].errors &&
                        broker['Province'].errors['required']
                      ">
                        {{lang.Please_select_province}}
                      </div>
                      <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
                <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                    </div>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="Corporation" class="Corporation">{{lang.Postal_Code}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="postalcode" placeholder={{lang.Postal_Code}}
                      onkeyup="this.value = this.value.toUpperCase();" formControlName="postalCode"
                      (input)="changeTextToUppercase('postalcode', $event)" />
                    <div *ngIf="broker['postalCode'].touched" class="help-block text-danger">
                      <div *ngIf="
                        broker['postalCode'].errors &&
                        broker['postalCode'].errors['required']
                      ">
                      {{lang.Please_enter_postal_code}}
                      </div>
                      <div *ngIf="
                        invalidpostalcodeprivince ||
                        (broker['postalCode'].touched &&
                          broker['postalCode'].hasError('invalidPostalCode'))
                      ">
                        {{lang.Please_enter_valid_postal_code}}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Add Group Contacts -->
                <div class="row">
                  <div class="form-group col-12 pt-2">
                    <h6 class="admintitle">
                      {{lang.Group_Contacts}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>
                  </div>
                </div>

                <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()" *ngIf="addadminform">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

                        <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                          formControlName="firstName" style="text-transform: capitalize" />

                        <div *ngIf="
                          grpcontact['firstName'].touched &&
                          grpcontact['firstName'].invalid
                        " class="help-block text-danger">
                          <div *ngIf="
                            grpcontact['firstName'].errors &&
                            grpcontact['firstName'].errors['required']
                          ">
                            {{lang.Please_enter_first_Name}}
                          </div>
                          <div *ngIf="
                            grpcontact['firstName'].errors &&
                            grpcontact['firstName'].errors['minlength']
                          ">
                            {{lang.First_Name_minimum_of_1_Character_and_without_numbers}}
                          </div>
                          <div *ngIf="
                            grpcontact['firstName'].errors &&
                            grpcontact['firstName'].errors['maxlength']
                          ">
                            {{lang.First_name_must_not_exceed_20_characters}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

                        <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                          style="text-transform: capitalize" formControlName="lastName" />

                        <div *ngIf="
                          grpcontact['lastName'].touched &&
                          grpcontact['lastName'].invalid
                        " class="help-block text-danger">
                          <div *ngIf="
                            grpcontact['lastName'].errors &&
                            grpcontact['lastName'].errors['required']
                          ">
                            {{lang.Please_enter_Last_Name}}
                          </div>
                          <div *ngIf="
                            grpcontact['lastName'].errors &&
                            grpcontact['lastName'].errors['minlength']
                          ">
                            {{lang.Last_Name_minimum_of_1_Character_and_without_numbers}}
                          </div>
                          <div *ngIf="
                            grpcontact['lastName'].errors &&
                            grpcontact['lastName'].errors['maxlength']
                          ">
                            {{lang.Last_Name_must_not_exceed_20_characters}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span
                            style="color: red">*</span></label>

                        <input type="tel" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}}
                          (change)="
                          phoneFormatForGroupCont(adminform, 'phoneNumber')
                        " formControlName="phoneNumber" />

                        <div *ngIf="
                          grpcontact['phoneNumber'].touched &&
                          grpcontact['phoneNumber'].invalid
                        " class="help-block text-danger">
                          <div *ngIf="
                            grpcontact['phoneNumber'].errors &&
                            grpcontact['phoneNumber'].errors['required']
                          ">
                            {{lang.Please_enter_phone_number}}
                          </div>
                          <div *ngIf="
                            grpcontact['phoneNumber'].errors &&
                            grpcontact['phoneNumber'].errors['minlength']
                          ">
                            {{lang.Phone_number_minimum_of_10_digits}}
                          </div>
                          <div *ngIf="
                            grpcontact['phoneNumber'].errors &&
                            grpcontact['phoneNumber'].errors['maxlength']
                          ">
                            {{lang.Phone_number_maximum_of_10_digits}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                        <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                          formControlName="email" (keypress)="checkEmailValidation($event)" />
                        <div *ngIf="
                          grpcontact['email'].touched &&
                          grpcontact['email'].invalid
                        " class="help-block text-danger">
                          <div *ngIf="
                            grpcontact['email'].errors &&
                            grpcontact['email'].errors['required']
                          ">
                            {{lang.Please_enter_email}}
                          </div>
                          <div *ngIf="
                            grpcontact['email'].errors &&
                            grpcontact['email'].errors['pattern']
                          ">
                            {{lang.Please_enter_valid_email}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

                        <select (change)="groupContactChange($event)" class="form-control" id="adminrole"
                          formControlName="role" placeholder="Role">
                          <option value="null" selected>{{lang.Select}}</option>
                          <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                            {{ name.display }}
                          </option>
                          <!-- <option value="Others">Others</option> -->
                        </select>

                        <div *ngIf="
                          grpcontact['role'].touched &&
                          grpcontact['role'].invalid
                        " class="help-block text-danger">
                          <div *ngIf="
                            grpcontact['role'].errors &&
                            grpcontact['role'].errors['required']
                          ">
                            {{lang.Please_select_role}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4" *ngIf="ShowOthers">
                      <div class="form-group">
                        <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

                        <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                          formControlName="roleName" />
                        <div *ngIf="
                          grpcontact['roleName'].touched &&
                          grpcontact['roleName'].invalid
                        " class="help-block text-danger">
                          <div *ngIf="
                            grpcontact['roleName'].errors &&
                            grpcontact['roleName'].errors['required']
                          ">
                           {{lang.please_enter_role}}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-12 pt-2">
                      <button [hidden]="adminform.invalid" type="submit" class="btn btn-primary">
                        {{lang.Save}}
                      </button>
                    </div>
                  </div>
                </form>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group" style="margin-bottom: 3px">
                      <div style="overflow: auto; direction: ltr; width: 100%">
                        <table align="left" *ngIf="showaddadmin">
                          <tr>
                            <th>{{lang.First_Name}}</th>
                            <th>{{lang.Last_Name}}</th>
                            <th>{{lang.Phone_Number}}</th>
                            <th>{{lang.Email}}</th>
                            <th>{{lang.Role}}</th>
                            <th></th>
                          </tr>
                          <tbody>
                            <tr *ngFor="let admin of adminData; let i = index" [ngClass]="{
                              orange: i % 2 == 0,
                              white: i % 2 != 0
                            }">
                              <td>{{ admin.firstName }}</td>
                              <td>{{ admin.lastName }}</td>
                              <td>{{admin.phoneNumber|phoneFormat}}</td>
                              <td>{{ admin.email }}</td>
                              <td>
                                <span *ngIf="admin.role == 'ADVISOR_EXECUTIVE'">{{lang.Executive}}</span>
                                <span *ngIf="admin.role == 'ADVISOR_ADMINISTRATOR'">{{lang.Administrator}}</span>
                                <span *ngIf="admin.role == 'ADVISOR_CONTACT'">{{lang.Support}}</span>
                                <span *ngIf="admin.role == 'ADVISOR_OTHERS'">{{
                                  admin.roleName
                                  }}</span>
                              </td>

                              <td style="text-align: right; display: flex">
                                <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                  data-bs-target="#basicModaleditgroupcontact" (click)="editadmin(admin, i)">
                                  <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                  class="btn btn-default deleteicon" (click)="deleteadmin(admin, i)">
                                  <i class="bi bi-trash-fill"></i>
                                </button>

                                <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleditgroupcontact"(click)="editadmin(admin,i)">Edit</button>&nbsp;
                          <button class="brokertablestatus" style="color:red" (click)="deleteadmin(admin,i)">Delete</button> -->
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <button *ngIf="showaddadmin" class="btn btn-primary addgroupadmininfo" type="button"
                      data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontact"
                      (click)="clearGroupContactData()">
                      {{lang.Add_More}}
                    </button>
                  </div>
                </div>
                <!-- LinceInformation -->
                <div class="row">
                  <div class="form-group col-12">
                    <h6 class="admintitle">
                      {{lang.License_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>
                  </div>
                </div>

                <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()" *ngIf="addlicenseform">
                  <div class="input-wrapper row">
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

                      <input type="text" class="form-control checking-field" id="licenseNumber"
                        placeholder={{lang.License}} formControlName="licenseNo" style="text-transform: capitalize" />

                      <div *ngIf="
                        f['licenseNo'].touched && f['licenseNo'].invalid
                      " class="help-block text-danger">
                        <div *ngIf="
                          f['licenseNo'].errors &&
                          f['licenseNo'].errors['required']
                        ">
                          {{lang.Please_enter_license_number}}
                        </div>
                        <div *ngIf="
                          f['licenseNo'].errors &&
                          f['licenseNo'].errors['minlength']
                        ">
                         {{lang.License_number_must_be_atleast_3_characters}}
                        </div>
                        <div *ngIf="
                          f['licenseNo'].errors &&
                          f['licenseNo'].errors['maxlength']
                        ">
                          {{lang.License_number_must_not_exceed_100_characters}}s
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

                      <select class="form-control" formControlName="licenseCoverage">
                        <option value="" selected>{{lang.Select}}</option>
                        <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                          {{ name.display }}
                        </option>
                      </select>
                      <!-- <select class="form-control" formControlName="licenseCoverage1">
                  <option value="" Selected>Select</option>
                </select> -->

                      <div *ngIf="
                        f['licenseCoverage'].touched &&
                        f['licenseCoverage'].invalid
                      " class="help-block text-danger">
                        <div *ngIf="
                          f['licenseCoverage'].errors &&
                          f['licenseCoverage'].errors['required']
                        ">
                          {{lang.Please_select_license_coverage}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

                      <select class="form-control" id="state" placeholder={{lang.Province}} formControlName="state"
                        (change)="insuranceprovincelist($event)">
                        <option value="" label="" disabled>Select</option>
                        <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                          {{ name.shortName }}
                        </option>
                      </select>

                      <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                        <div *ngIf="
                          f['state'].errors && f['state'].errors['required']
                        ">
                          {{lang.Please_select_province}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

                      <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" [min]="minDate"
                        formControlName="expiryDate" bsDatepicker [placement]='"top"' [minDate]="todayDate"
                        [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" (onShown)="disableScrolling()"
                        (onHidden)="enableScrolling()" />
                      <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                        <div *ngIf="
                          f['expiryDate'].errors &&
                          f['expiryDate'].errors['required']
                        ">
                          {{lang.Please_select_expiry_date}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span
                          style="color: red">*</span></label>
                      <input type="text" class="form-control checking-field" id="remainder_days" value="30"
                        placeholder={{lang.Reminder_Days}} (keypress)="numberOnly($event)" formControlName="reminderMailDays"
                        style="text-transform: capitalize" />

                      <div *ngIf="
                        f['reminderMailDays'].touched &&
                        f['reminderMailDays'].invalid
                      " class="help-block text-danger">
                        <div *ngIf="
                          f['reminderMailDays'].errors &&
                          f['reminderMailDays'].errors['required']
                        ">
                          {{lang.Please_enter_reminder_email_days}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-12">
                      <button type="submit" [hidden]="licenseform.invalid" class="btn btn-primary">
                        {{lang.Save}}
                      </button>
                    </div>
                  </div>
                </form>
                <!-- lincenseInfo Table -->
                <div class="row">
                  <div class="form-group col-12">
                    <div style="direction: ltr; width: 100%">
                      <div class="row">
                        <div class="form-group col-12" style="margin-bottom: 3px">
                          <!-- <div style="overflow: auto; direction:ltr;  width: 100%;"> -->
                          <table align="left" *ngIf="addlicenseformtable">
                            <tr>
                              <th>{{lang.License}} #</th>
                              <th>{{lang.Coverage}}</th>
                              <th>{{lang.Province}}</th>
                              <th>{{lang.Expiry_Date}}</th>
                              <th>{{lang.Reminder_Days}}</th>
                              <th></th>
                            </tr>
                            <tbody>
                              <tr *ngFor="
                                let broker of addlicenseformData;
                                let i = index
                              " [ngClass]="{
                                orange: i % 2 == 0,
                                white: i % 2 != 0
                              }">
                                <td>
                                  <input type="text" class="form-control checking-field" id="licenseNumber"
                                    [(ngModel)]="broker.licenseNo" [ngModelOptions]="{ standalone: true }" [disabled]="
                                    isEditable || enableEditIndex != i
                                  " />
                                </td>
                                <td>
                                  <select class="form-control" id="licenseCoverage" placeholder="Select"
                                    [(ngModel)]="broker.licenseCoverage" [ngModelOptions]="{ standalone: true }"
                                    [disabled]="
                                    isEditable || enableEditIndex != i
                                  ">
                                    <option value="" disabled>{{lang.Select}}</option>

                                    <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                                      {{ name.display }}
                                    </option>
                                  </select>
                                </td>
                                <td>
                                  <select class="form-control" id="province" placeholder="Select"
                                    (change)="insuranceprovincelist($event)" [(ngModel)]="broker.provinceshortName"
                                    [ngModelOptions]="{ standalone: true }" [disabled]="
                                    isEditable || enableEditIndex != i
                                  ">
                                    <option value="" disabled>{{lang.Select}}</option>
                                    <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                                      {{ name.shortName }}
                                    </option>
                                  </select>
                                </td>
                                <td>
                                  <input type="text" placeholder="Expiry Date" class="form-control" [min]="minDate"
                                    [(ngModel)]="broker.expiryDate" [ngModelOptions]="{ standalone: true }" [disabled]="
                                    isEditable || enableEditIndex != i
                                  " bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"/>
                                </td>
                                <td>
                                  <input type="text" class="form-control checking-field" id="remainder_days"
                                    placeholder="Reminder Days" (keypress)="numberOnly($event)"
                                    [(ngModel)]="broker.reminderMailDays" [ngModelOptions]="{ standalone: true }"
                                    style="text-transform: capitalize" [disabled]="
                                    isEditable || enableEditIndex != i
                                  " />
                                </td>
                                <td style="display: flex; margin-top: 10px">
                                  <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                    data-bs-target="#basicModaledit" (click)="
                                    editadvisorlicenseDetails($event, i, broker)
                                  " *ngIf="enableEditIndex != i">
                                    <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                    class="btn btn-default deleteicon" (click)="deletelicense(broker, i)"
                                    *ngIf="enableEditIndex != i">
                                    <i class="bi bi-trash-fill"></i>
                                  </button>

                                  <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaledit" (click)="editadvisorlicenseDetails($event, i,broker)" *ngIf="enableEditIndex != i">Edit</button>&nbsp;
                              <button class="brokertablestatus" style="color:red" (click)="deletelicense(broker,i)" *ngIf="enableEditIndex != i">Delete</button> -->
                                  <button class="brokertablestatus" style="color: green"
                                    *ngIf="!isEditable && enableEditIndex == i" (click)="saveLicense(broker, i)">
                                    {{lang.Save}}</button>&nbsp;
                                  <button class="brokertablestatus" style="color: red"
                                    *ngIf="!isEditable && enableEditIndex == i" (click)="cancellicneseEdit($event, i)">
                                    {{lang.Cancel}}
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- <button *ngIf="addlicenseformtable"  class="btn btn-primary addgroupadmininfo" type="button"  data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="hidegrpadmindetails()" >{{lang.Add_More}}</button> -->

                          <!-- </div> -->
                        </div>
                      </div>

                      <button *ngIf="addlicenseformtable" class="btn btn-primary addgroupadmininfo" type="button"
                        data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="addnewlicense()">
                        {{lang.Add_More}}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- {{lang.E_O_Information}} -->
                <div class="row pt-2">
                  <div class="form-group col-12">
                    <h6 class="admintitle">
                      {{lang.E_O_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                    </h6>
                  </div>
                </div>

                <form class="onbordingform" [formGroup]="eoform" (ngSubmit)="addEOformDetails()" *ngIf="addEOform">
                  <div class="input-wrapper row">
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>
                      <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                        formControlName="insurerName" style="text-transform: capitalize" />
                      <div *ngIf="
                        eo['insurerName'].touched && eo['insurerName'].invalid
                      " class="help-block text-danger">
                        <div *ngIf="
                          eo['insurerName'].errors &&
                          eo['insurerName'].errors['required']
                        ">
                          {{lang.Please_enter_Insurance_name}}
                        </div>
                        <div *ngIf="
                          eo['insurerName'].errors &&
                          eo['insurerName'].errors['minlength']
                        ">
                          {{lang.Insurer_name_must_be_atleast_3_characters}}
                        </div>
                        <div *ngIf="
                          eo['insurerName'].errors &&
                          eo['insurerName'].errors['maxlength']
                        ">
                          {{lang.Insurer_name_must_not_exceed_100_characters}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
                      <input type="text" class="form-control checking-field" id="certificateNumber"
                        placeholder={{lang.Certificate}} formControlName="certificateNo" />

                      <div *ngIf="
                        eo['certificateNo'].touched &&
                        eo['certificateNo'].invalid
                      " class="help-block text-danger">
                        <div *ngIf="
                          eo['certificateNo'].errors &&
                          eo['certificateNo'].errors['required']
                        ">
                          {{lang.Please_select_Certificate_Name}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

                      <input type="text" class="form-control checking-field" id="PolicyNumber"
                        placeholder={{lang.Policy}} formControlName="policyNo" />

                      <div *ngIf="eo['policyNo'].touched && eo['policyNo'].invalid" class="help-block text-danger">
                        <div *ngIf="
                          eo['policyNo'].errors && eo['policyNo'].errors['required']
                        ">
                          {{lang.Please_enter_Policy_Number}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="input-wrapper row">
                    <div class="form-group col-md-4">
                      <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

                      <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                        [placement]='"top"' (onShown)="disableScrolling()" (onHidden)="enableScrolling()"
                        [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                      <div *ngIf="
                        eo['expiryDate'].touched &&
                        eo['expiryDate'].invalid
                      " class="help-block text-danger">
                        <div *ngIf="
                          eo['expiryDate'].errors &&
                          eo['expiryDate'].errors['required']
                        ">
                          {{lang.Please_select_expiry_date}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-4"></div>
                    <div class="form-group col-12">
                      <button type="submit" [hidden]="eoform.invalid" class="btn btn-primary">
                        {{lang.Save}}
                      </button>
                    </div>
                  </div>
                </form>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <div style="overflow: auto; direction: ltr; width: 100%">
                        <table align="left" *ngIf="showaddEOdetails">
                          <tr>
                            <th>{{lang.Insurer_Name}}</th>
                            <th>{{lang.Certificate}} #</th>
                            <th>{{lang.Policy}} #</th>
                            <th>{{lang.Expiry_Date}}</th>
                            <th></th>
                          </tr>
                          <tbody>
                            <tr>
                              <td>{{ EOinsurenceInfo.insurerName }}</td>
                              <td>
                                {{ EOinsurenceInfo.certificateNo | titlecase }}
                              </td>
                              <td>{{ EOinsurenceInfo.policyNo }}</td>
                              <td>
                                {{
                                EOinsurenceInfo.expiryDate
                                | date: 'MMM dd, yyyy'
                                }}
                              </td>
                              <td style="text-align: right; display: flex">
                                <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                  data-bs-target="#basicModaleoedit" (click)="editEO()">
                                  <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                  class="btn btn-default deleteicon" (click)="deleteEO()">
                                  <i class="bi bi-trash-fill"></i>
                                </button>

                                <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleoedit"(click)="editEO()">Edit</button>&nbsp;
                        <button class="brokertablestatus" style="color:red" (click)="deleteEO()">Delete</button> -->
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <!-- <button *ngIf="showaddadmin"  class="btn btn-primary addgroupadmininfo" type="button"  data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontact" (click)="hidegrpadmindetails()" >{{lang.Add_More}}</button> -->
                  </div>
                </div>
                <br>
                <div style="display: flex;justify-content: flex-end;">
                  <button class="btn btn-primary" type="button" (click)="showsalesTrackingData()">
                    {{lang.Submit}}
                  </button>&nbsp;


                </div>



              </div>


              <div class="row" *ngIf="showsalestrackingtable">
                <div class="form-group col-12">
                  <h6 class="admintitle">
                    {{lang.Sales_Tracking_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                  </h6>
                </div>
              </div>


              <div class="row salescracking" *ngIf="showsalestrackinCodeAuto">
                <div class="row">
                  <div class="col-md-6">
                    <table class="table table-striped table-bordered" style="margin-top:5px">
                      <thead>
                        <tr>
                          <th style='width:80%'>{{lang.broker}}</th>
                          <th style='width:10%'>{{lang.Commissions}}</th>
                          <th style='width:10%'></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let dynamic of brokersalesCodes; let i = index">
                          <td>
                            {{dynamic.brokerName}}
                          </td>
                          <td>
                            <input class="form-control" name="{{ dynamic.commission }}" [(ngModel)]="dynamic.commission"
                              [ngModelOptions]="{ standalone: true }" type="text" maxlength="5" placeholder=""
                              (change)="checkCommisionCode($event)">
                          </td>
                          <td>
                            <button class="fa fa-trash-o deletetier" (click)="deleteRow(i, dynamic)"></button>
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                          <td [ngStyle]="{ 'color': (totalValue==100 ? 'green' : 'red') }">{{totalValue}}/100</td>
                          <td></td>
                          <!-- <td></td> -->

                        </tr>
                      </tbody>
                    </table>

                  </div>
                  <div class="col-md-6">

                    <canvas id="MyChart">{{ chart }}</canvas>
                  </div>
                </div>


              </div>

              <!-- <div *ngIf="showsalestrackinCodeAuto">
              <canvas  id="MyChart" >{{ chart }}</canvas>
            </div> -->

              <div *ngIf="showsharedformData">
                <form class="onbordingform form-container linescrollbar" [formGroup]="brokerSharedregform">
                  <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
                    <div class="form-group col-md-6">
                      <label for="Corporation" class="Corporation">{{lang.Brokerage_Parent_Advisor}}</label>

                      <select class="form-control select2" id="parentidrole" placeholder="Select"
                        formControlName="ParentbrokerName" data-live-search="true" (change)="getBrokerlistData($event)">
                        <option value="" label="">{{lang.Select}}</option>
                        <option *ngFor="let broker of allBrokersUnique" [value]="broker.id">
                          <!-- {{ broker.fullName }} -->
                          {{ broker.name }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                          <!-- {{broker.salesTrackingCodeWithStatement}} -->
                        </option>
                      </select>

                      <div *ngIf="
                  brokerShared['ParentbrokerName'].touched &&
                  brokerShared['ParentbrokerName'].invalid
                " class="help-block text-danger">
                        <div *ngIf="
                    brokerShared['ParentbrokerName'].errors &&
                    brokerShared['ParentbrokerName'].errors['required']
                  ">
                          {{lang.Please_select_parent_advisor}}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6">
                      <label for="Corporation" class="Corporation">{{lang.Shared_account_name}}</label>

                      <input type="text" class="form-control checking-field" id="nameofcorporation"
                        placeholder="Name of shared account" style="text-transform: capitalize"
                        formControlName="brokersName" (change)="checkAdvsiorNameExistShared()" />
                      <div *ngIf="
                      brokerShared['brokersName'].touched &&
                      brokerShared['brokersName'].invalid
                    " class="help-block text-danger">
                        <div *ngIf="
                        brokerShared['brokersName'].errors &&
                        brokerShared['brokersName'].errors['required']
                      ">
                          {{lang.Please_enter_broker_name}}
                        </div>
                        <div *ngIf="
                        brokerShared['brokersName'].errors &&
                        brokerShared['brokersName'].errors['minlength']
                      ">
                          <!-- {{lang.Broker_name_must_be_atleast_3_characters}} -->
                           Broker Name must be minimum of 1 character
                        </div>
                        <div *ngIf="
                        brokerShared['brokersName'].errors &&
                        brokerShared['brokersName'].errors['maxlength']
                      ">
                          {{lang.Broker_name_must_not_exceed_255_characters}}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                  <br>
                  <div style="display: flex;justify-content: flex-end;">
                    <button class="btn btn-primary" type="button" (click)="submitSharedNewandexisting()">
                      {{lang.Submit}}
                    </button>&nbsp;
                  </div>
                  <!-- <button class="btn btn-primary addgroupadmininfo" type="button" (click)="addRow()">
          {{lang.Add_More}}
        </button> -->






                </form>
              </div>

              <div class="row" *ngIf="showsalestrackingtable">
                <div class="form-group col-12 mb-2">
                  <div style="direction: ltr; width: 100%">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <table align="center">
                          <thead>
                            <tr>
                              <th>{{lang.Sales_Tracking_code}}</th>
                              <th>{{lang.Name}}</th>
                              <th>{{lang.Type}}</th>
                              <th>{{lang.Percentage}}</th>
                              <!-- <th></th> -->
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{{ salesTrackingInfo.salesTrackingCode }}</td>
                              <td>
                                {{ salesTrackingInfo.name }}
                                <!-- <ng-container
                                *ngFor="let salesdata of sales.salesTrackingCode.salesTrackingCodeShares">
                                <div>{{ salesdata.broker.name }}</div>
                              </ng-container> -->
                              </td>
                              <td>
                                {{ salesTrackingInfo.brokerType }}

                                <!-- <ng-container
                                *ngFor="let salesdata of sales.salesTrackingCode.salesTrackingCodeShares">
                                <div>{{ salesdata.broker.brokerType }}</div>
                              </ng-container> -->
                              </td>
                              <td>
                                100%
                                <!-- <ng-container
                                *ngFor="let salesdata of sales.salesTrackingCode.salesTrackingCodeShares">
                                <div class="text-start">{{ salesdata.percentage }}%</div>
                              </ng-container> -->

                              </td>
                              <!-- <td class="text-center">
                              <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                data-bs-target="#salesTrackingEdit"
                                (click)="editSaleslTrackingCode($event, i,sales)">
                                <i class="bi bi-pencil-fill"></i>
                              </button>
                            </td> -->

                            </tr>
                          </tbody>
                        </table>

                      </div>
                    </div>

                  </div>
                </div>
              </div>

            </form>

            <br />

          </div>
        </div>
        <div class="text-end">
          <div *ngIf="saveError" class="text-danger text-end" style="font-size:12px">
            <!-- {{lang.Please_save_signup_form}} -->
            Please save enrollment form
          </div>
          <button class="saveAndNext" id="basicformSubmit123" type="button" *ngIf="showAdvisorAdvData"
            (click)="submitbasicFormInfo()">
            {{lang.Save}}&nbsp;&nbsp;<i aria-hidden="true" class="fa fa-long-arrow-right"></i></button>

        </div>
      </div>
      <div class="col-sm-2 actionspage">
        <div class="row">
          <div class="form-group col-12 ">
            <!-- <h6 class="actionsrequired">Welcome {{ adminName | titlecase }}</h6> -->
            <h6 class="actionsrequired text-center">{{lang.Notifications}}</h6>

          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<!-- Model For Add Broker License -->
<div class="modal fade" id="basicModal1" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Broker_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNo" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNo'].touched && f['licenseNo'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

              <select class="form-control" id="Province"  formControlName="state"
                (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                (keypress)="numberOnly($event)" formControlName="reminderMailDays" style="text-transform: capitalize" />

              <div *ngIf="
                  f['reminderMailDays'].touched && f['reminderMailDays'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['reminderMailDays'].errors &&
                    f['reminderMailDays'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hideaddlicenseform()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="licenseform.invalid" (click)="addlicense()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- Model For Add shared local_convenience_store -->
<div class="modal fade" id="basicModal1Shared" data-bs-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Broker_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hideaddlicenseformShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNo" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNo'].touched && f['licenseNo'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                 {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                (keypress)="numberOnly($event)" formControlName="reminderMailDays" style="text-transform: capitalize" />

              <div *ngIf="
                  f['reminderMailDays'].touched && f['reminderMailDays'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['reminderMailDays'].errors &&
                    f['reminderMailDays'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hideaddlicenseformShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="licenseform.invalid" (click)="addlicenseShared()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- Model For Add Form -->
<div class="modal modal-lg fade" id="addFormDetails" tabindex="-1" style="max-width:100%">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 1200px; margin-left: -325px" *ngIf="showaddplanss">
      <div class="modal-header">
        <!-- <h6 class="modal-title">{{lang.Add_Signup_Form}}</h6> -->
        <h6 class="modal-title">Add Enrollment Form</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="resetFormCreation()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation">
          <div class="input-wrapper row">

            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">
                <!-- {{lang.Select_Profile_for_signup}} -->
                Select Profile for enrollment
                <span
                  style="color: red">*</span></label>
              <select class="form-control select2" id="parentidrole" placeholder="Select" formControlName="profileName"
                data-live-search="true" (change)="getProfilebasedid($event)">
                <option value="" label="">{{lang.Select}}</option>
                <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                  {{profile.name}}({{profile.additionalData.statement}})
                </option>
              </select>

              <div *ngIf="
                                  form['profileName'].touched && form['profileName'].invalid
                                " class="help-block text-danger">
                <div *ngIf="
                                    form['profileName'].errors &&
                                    form['profileName'].errors['required']
                                  ">
                  {{lang.Please_select_profile}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">

            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                [(ngModel)]="formTitle" formControlName="formName" style="text-transform: capitalize" />

              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                [(ngModel)]="formDescription" formControlName="formDescription" style="text-transform: capitalize" />

              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                 {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation1">{{lang.Apply_Parent_Logo}}<span style="color: red">*</span></label>
              <br />
              <div class="d-flex">
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="formapplylogo" id="formapplylogoyes" value="true"
                    formControlName="formapplylogo" (change)="checkParentFormlogo($event)" />
                  <label for="formapplylogoyes" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                </div>
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="formapplylogo" id="formapplylogono" value="false"
                    formControlName="formapplylogo" (change)="checkParentFormlogo($event)" />
                  <label for="formapplylogono" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                </div>
              </div>

              <div *ngIf="
                              form['formapplylogo'].touched && form['formapplylogo'].invalid
                            " class="help-block text-danger">
                <div *ngIf="
                                form['formapplylogo'].errors &&
                                form['formapplylogo'].errors['required']
                              ">
                  {{lang.Please_select_logo_type}}
                </div>
              </div>

              <div class="form-group " *ngIf="showparentformlogocondition">
                <label for="Corporation" class="Corporation">{{lang.Logo}}</label>
                <input type="file" class="form-control checking-field" id="formlogo" placeholder="logo"
                  formControlName="formlogo" (change)="uploadadminFormlogo($event)" />

                <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
                  <div *ngIf="
                                  form['formlogo'].errors &&
                                  form['formlogo'].errors['required']
                                ">
                    {{lang.Please_choose_form_logo}}
                  </div>
                </div>
              </div>
              <div *ngIf="showParentLogoDisplay" class="uploadCorporateLogo">

                <label for="adminformlogo" class="adminformlogo" id="fileSaver">
                  <img [src]="displaylogo" style="max-height: 50px;max-width:100px" />
                </label>

              </div>

            </div>
          </div>

          <app-common-plans
            #advisorAdd
            [isAdvisor]="true"
            [viewPlan]="false"
            [advisorPackages]="productsArray"
            [allplansArray]="allplansArray"
            (submitTriggered)="addform1()"
            [editFormPricingOptions]=""
            [selectedPlanLevels]="[]"
            >
          </app-common-plans>

          <div class="input-wrapper row border border-dark mx-1  mt-2 linescrollbar"
            style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans && false">

            <div *ngFor="let product of productsArray; let i=index" class="mt-2">

              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width:430px;" [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                  <span class="my-auto col-1 ">
                    <input type="checkbox" id="package{{product.id}}"
                      [disabled]="allplansArray[product.name]?.disabled===true"
                      [checked]="allplansArray[product.name]?.packageCheckbox===true"
                      (change)="toggleAllPlans(product.name,product.id, $event)" />
                  </span>
                  <div class="my-auto mb-1 col-10 text-center">
                    <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                        *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                        title="Unpublished"></i></span>
                  </div>
                  <div *ngIf="role==='ADMINISTRATOR'" title="{{getTextForTooltip1(product.published,product.restrict)}}"
                    [ngStyle]=" { 'border-color' : getColorForPlans1(product.published,product.restrict) }"
                    class="outer my-auto ms-3 col-2" data-bs-toggle="">
                    <span class="inner"
                      [ngStyle]="{ 'background': getColorForPlans1(product.published,product.restrict) }"></span>
                  </div>
                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width:210px">

                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                        [checked]="allplansArray[product.name][plans.key]?.checked===true"
                        (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                  </div>
                  <div
                    [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'" class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                                          align-items-center gap-1 row py-1 rounded" style="width:210px ">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{plan.id}}"
                            [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                            [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                            (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                        </div>
                        <div class="my-auto col-9 mb-1  " style="font-size:12px">
                          <span>{{ plan.name }}</span>

                        </div>
                        <div *ngIf="role==='ADMINISTRATOR'"
                          title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                          [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                        </div>

                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                        <label class="Corporation">{{lang.Pricing}} </label>
                        <select type="" class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          (change)="selectPricingOptions" formControlName="pricingOptions">
                          <option selected value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <hr style="    height: 2px;
                              background-color: black;">
            </div>
          </div>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="addform1()">
          {{lang.Save}}
        </button> -->
        <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="advisorAdd.addForm()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>
<!-- Model For Edit broker  license -->
<div class="modal fade" id="basicModaledit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNo" [(ngModel)]="editbrokerlicensenumber" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNo'].touched && f['licenseNo'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage"
                [(ngModel)]="editbrokerlicensecoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                [(ngModel)]="editbrokerlicenseshortName" (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" [(ngModel)]="editbrokerlicenseexpirydate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                [(ngModel)]="editbrokerlicenseexpiryremainder" (keypress)="numberOnly($event)"
                formControlName="reminderMailDays" style="text-transform: capitalize" />

              <div *ngIf="
                  f['reminderMailDays'].touched && f['reminderMailDays'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['reminderMailDays'].errors &&
                    f['reminderMailDays'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_email_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="hideaddlicenseform btn-secondary" data-bs-dismiss="modal"
          (click)="hideaddlicenseform()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editbrokerlicenseSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- Model for edit license Shared broker -->
<div class="modal fade" id="basicModaleditShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_License}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hideaddlicenseformShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="licenseform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="licenseNumber" placeholder={{lang.License}}
                formControlName="licenseNo" [(ngModel)]="editbrokerlicensenumber" style="text-transform: capitalize" />

              <div *ngIf="f['licenseNo'].touched && f['licenseNo'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['required']
                  ">
                  {{lang.Please_enter_license_number}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['minlength']
                  ">
                  {{lang.License_number_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['maxlength']
                  ">
                  {{lang.License_number_must_not_exceed_100_characters}}s
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

              <select class="form-control" id="licenseCoverage" placeholder="Select" formControlName="licenseCoverage"
                [(ngModel)]="editbrokerlicensecoverage">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                  {{ name.display }}
                </option>
              </select>

              <div *ngIf="
                  f['licenseCoverage'].touched && f['licenseCoverage'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                  {{lang.Please_select_license_coverage}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

              <select class="form-control" id="Province" placeholder="Select" formControlName="state"
                [(ngModel)]="editbrokerlicenseshortName" (change)="insuranceprovincelist($event)">
                <option value="">{{lang.Select}}</option>

                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                  {{ name.shortName }}
                </option>
              </select>

              <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                <div *ngIf="f['state'].errors && f['state'].errors['required']">
                  {{lang.Please_select_province}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" [(ngModel)]="editbrokerlicenseexpirydate" bsDatepicker
                [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                <div *ngIf="
                    f['expiryDate'].errors && f['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="remainder_days" placeholder={{lang.Reminder_Days}}
                [(ngModel)]="editbrokerlicenseexpiryremainder" (keypress)="numberOnly($event)"
                formControlName="reminderMailDays" style="text-transform: capitalize" />

              <div *ngIf="
                  f['reminderMailDays'].touched && f['reminderMailDays'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    f['reminderMailDays'].errors &&
                    f['reminderMailDays'].errors['required']
                  ">
                  {{lang.Please_enter_reminder_email_days}}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="hideaddlicenseform btn-secondary" data-bs-dismiss="modal"
          (click)="hideaddlicenseformShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editbrokerlicenseSharedSubmit()">
         {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Model For Edit form Details -->
<div class="modal fade" id="basicModalFormedit12" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 1200px; margin-left: -325px">
      <div class="modal-header">
        <h6 class="modal-title">
          Edit enrollment Form Details
        </h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="resetFormCreation()"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation" (ngSubmit)="addform()">
          <div class="input-wrapper row">

            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">
                <!-- {{lang.Select_Profile_for_signup}} -->
                Select Profile for enrollment
                <span
                  style="color: red">*</span></label>
              <select class="form-control select2" id="parentidrole" placeholder="Select" [(ngModel)]="editFormProfile"
                formControlName="profileName" data-live-search="true" (change)="getProfilebasedid($event)">
                <option value="" label="">Select</option>
                <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                  {{profile.name}}({{profile.additionalData.statement}})
                </option>
              </select>

              <div *ngIf="
                                  form['profileName'].touched && form['profileName'].invalid
                                " class="help-block text-danger">
                <div *ngIf="
                                    form['profileName'].errors &&
                                    form['profileName'].errors['required']
                                  ">
                  {{lang.Please_select_profile}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                [(ngModel)]="editFormName" formControlName="formName" style="text-transform: capitalize" />
              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                [(ngModel)]="editFormDescription" formControlName="formDescription"
                style="text-transform: capitalize" />
              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                  {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation1">{{lang.Apply_Parent_Logo}}<span style="color: red">*</span></label>
              <br />
              <div class="d-flex">
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="formapplylogo" id="formapplylogoyes" value="true"
                    formControlName="formapplylogo" (change)="checkParentFormlogo($event)" #formlogoyes />
                  <label for="formapplylogoyes" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                </div>
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="formapplylogo" id="formapplylogono" value="false"
                    formControlName="formapplylogo" (change)="checkParentFormlogo($event)" #formlogono />
                  <label for="formapplylogono" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                </div>
              </div>

              <div *ngIf="form['formapplylogo'].touched && form['formapplylogo'].invalid"
                class="help-block text-danger">
                <div *ngIf="form['formapplylogo'].errors &&form['formapplylogo'].errors['required']">
                  {{lang.Please_select_logo_type}}
                </div>
              </div>

              <div class="form-group " *ngIf="showparentformlogocondition">
                <label for="Corporation" class="Corporation">{{lang.Logo}}</label>
                <div class="uploadCorporateLogo" *ngIf="
                                editFormdisplaylogo   ;
                                else showLogo
                              ">
                  <label for="adminformlogo" class="adminformlogo">
                    <img [src]="editFormdisplaylogo" style="max-height: 50px;max-width:100px" />
                  </label>
                  <input id="adminformlogo" class="form-control checking-field" style="display: none" type="file"
                    accept="image/*" formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
                </div>
                <ng-template #showLogo>
                  <input id="adminformlogo" class="form-control checking-field" type="file" accept="image/*"
                    formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
                </ng-template>
              </div>
              <div *ngIf="showParentLogoDisplay" class="uploadCorporateLogo">

                <label for="adminformlogo" class="adminformlogo" id="fileSaver">
                  <img [src]="displaylogo" style="max-height: 50px;max-width:100px" />
                </label>

              </div>
              <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
                <div *ngIf="
                                form['formlogo'].errors && form['formlogo'].errors['required']
                              ">
                  {{lang.Please_choose_form_logo}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">


          </div>

          <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
            style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans">

            <div *ngFor="let product of productsArray; let i=index" class="mt-2">

              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width:430px;" [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                  <span class="my-auto col-1 ">
                    <input type="checkbox" id="package{{product.id}}"
                      [disabled]="allplansArray[product.name]?.disabled===true"
                      [checked]="allplansArray[product.name]?.packageCheckbox===true"
                      (change)="toggleAllPlans(product.name,product.id, $event)" />
                  </span>
                  <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                      *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                      title="Unpublished"></i></span>
                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width:210px">

                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                        [checked]="allplansArray[product.name][plans.key]?.checked===true"
                        (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                  </div>
                  <div
                    [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'" class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                                        align-items-center gap-1 row py-1 rounded" style="width:210px ">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{plan.id}}"
                            [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                            [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                            (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                        </div>
                        <div class="my-auto col-9 mb-1  " style="font-size:12px">
                          <span>{{ plan.name }}</span>

                        </div>
                        <div *ngIf="role==='ADMINISTRATOR'"
                          title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                          [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                        </div>

                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                        <label class="Corporation">{{lang.Pricing}} </label>
                        <select class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          [(ngModel)]="editFormPricingOptions" formControlName="pricingOptions">
                          <option value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <hr style="    height: 2px;
                            background-color: black;">
            </div>
          </div>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editFormSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="basicModalFormedit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" style="width: 1200px; margin-left: -325px" *ngIf="showeditplans">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Signup_Form_Details}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="resetFormCreation()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="formCreation" (ngSubmit)="addform()">
          <div class="input-wrapper row">

            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Select_Profile_for_signup}}<span
                  style="color: red">*</span></label>
              <select class="form-control select2" id="parentidrole" placeholder="Select" [(ngModel)]="editFormProfile"
                formControlName="profileName" data-live-search="true" (change)="getProfilebasedid($event)">
                <option value="" selected>{{lang.Select}}</option>
                <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                  {{profile.name}}({{profile.additionalData.statement}})
                </option>
              </select>

              <div *ngIf="
                                  form['profileName'].touched && form['profileName'].invalid
                                " class="help-block text-danger">
                <div *ngIf="
                                    form['profileName'].errors &&
                                    form['profileName'].errors['required']
                                  ">
                  {{lang.Please_select_profile}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                [(ngModel)]="editFormName" formControlName="formName" style="text-transform: capitalize" />
              <div *ngIf="form['formName'].touched && form['formName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    form['formName'].errors &&
                    form['formName'].errors['required']
                  ">
                  {{lang.Please_enter_form_title}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
              <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                [(ngModel)]="editFormDescription" formControlName="formDescription"
                style="text-transform: capitalize" />
              <div *ngIf="
                  form['formDescription'].touched &&
                  form['formDescription'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    form['formDescription'].errors &&
                    form['formDescription'].errors['required']
                  ">
                  {{lang.Please_enter_form_description}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Logo}}
              </label>

              <div class="uploadCorporateLogo" *ngIf="editFormlogo && editFormlogo.length > 0; else showLogo">
                <label for="adminformlogo" class="adminformlogo">
                  <img [src]="editFormlogo" style="max-height: 50px ;max-width:100px" />
                </label>
                <input id="adminformlogo" class="form-control checking-field" style="display: none" type="file"
                  accept="image/*" formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
              </div>
              <ng-template #showLogo>
                <input id="adminformlogo" class="form-control checking-field" type="file" accept="image/*"
                  formControlName="formlogo" (change)="uploadadminFormlogo($event)" />
              </ng-template>
              <div class="text-end" style="font-size:10px">{{lang.Click_to_update_logo}}</div>
            </div>
            <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
              <div *ngIf="form['formlogo'].errors && form['formlogo'].errors['required']">
                {{lang.Please_choose_form_logo}}
              </div>
            </div>

          </div>

          <app-common-plans
            #advisor
            [isAdvisor]="true"
            [viewPlan]="false"
            [advisorPackages]="productsArray"
            [allplansArray]="allplansArray"
            [selectedPlanLevels]="selectedPlanLevels"
            [editFormPricingOptions]="editFormPricingOptions"
            (submitTriggered)="editFormSubmit()"
          >
          </app-common-plans>

          <div class="input-wrapper row border border-dark mx-1 mt-2 linescrollbar"
            style="font-size: 12px; width:100%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans && false">

            <div *ngFor="let product of productsArray; let i=index" class="mt-2">

              <div class="display-center">
                <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                  style="width:430px;" [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                  <span class="my-auto col-1 ">
                    <input type="checkbox" id="package{{product.id}}"
                      [disabled]="allplansArray[product.name]?.disabled===true"
                      [checked]="allplansArray[product.name]?.packageCheckbox===true"
                      (change)="toggleAllPlans(product.name,product.id, $event)" />
                  </span>
                  <div class="my-auto mb-1 col-10 text-center">
                    <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                        *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                        title="Unpublished"></i></span>
                  </div>
                  <div *ngIf="role==='ADMINISTRATOR'" title="{{getTextForTooltip1(product.published,product.restrict)}}"
                    [ngStyle]=" { 'border-color' : getColorForPlans1(product.published,product.restrict) }"
                    class="outer my-auto ms-3 col-2" data-bs-toggle="">
                    <span class="inner"
                      [ngStyle]="{ 'background': getColorForPlans1(product.published,product.restrict) }"></span>
                  </div>
                </div>
              </div>

              <div class="display-center mt-3 mb-4 flex-wrap">
                <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                  <div
                    class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                    *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width:210px">

                    <span class="my-auto col-1">
                      <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                        [checked]="allplansArray[product.name][plans.key]?.checked===true"
                        (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                    </span>
                    <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                  </div>
                  <div
                    [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                    <div *ngFor="let plan of plans.value">
                      <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'" class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                                          align-items-center gap-1 row py-1 rounded" style="width:210px ">
                        <!-- *ngIf="plan.parentId != null" -->
                        <div class="my-auto col-1">
                          <input type="checkbox" id="planCheckbox{{plan.id}}"
                            [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                            [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                            (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                        </div>
                        <div class="my-auto col-9 mb-1  " style="font-size:12px">
                          <span>{{ plan.name }}</span>

                        </div>
                        <div *ngIf="role==='ADMINISTRATOR'"
                          title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                          [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                          class="outer my-auto col-2" data-bs-toggle="">
                          <span class="inner"
                            [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                        </div>

                      </div>
                      <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                        <label class="Corporation">{{lang.Pricing}} </label>
                        <select class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                          [(ngModel)]="editFormPricingOptions" formControlName="pricingOptions">
                          <option value="">{{lang.Select}}</option>
                          <option *ngFor="let option of pricingOptions" [value]="option.key">
                            {{ option.display }}
                          </option>
                        </select>
                      </div>
                      <div>

                      </div>
                    </div>
                  </div>
                </div>

              </div>

              <hr style="    height: 2px;
                                    background-color: black;">
            </div>
          </div>
          <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
            {{lang.Please_select_atleast_one_plan}}
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="resetFormCreation()">
          {{lang.Close}}
        </button>
        <!-- <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="editFormSubmit()">
          {{lang.Save}}
        </button> -->
        <button type="button" class="btn btn-primary" [disabled]="formCreation.invalid" (click)="advisor.addForm()">
          {{lang.Save}}
        </button>
        <!-- [disabled]="formCreation.invalid" -->
      </div>
    </div>
  </div>
</div>

<!-- Edit Group Contact -->

<div class="modal fade" id="basicModaleditgroupcontact" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="phoneNum"
                (change)="phoneFormatDynamic('phoneNumber', 'grpcontact')" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" formControlName="phoneNumber" />

              <div *ngIf="
                  grpcontact['phoneNumber'].touched &&
                  grpcontact['phoneNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" (keypress)="checkEmailValidation($event)" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                        grpcontact['email'].errors &&
                        grpcontact['email'].errors['emailExist']
                                  ">
                  {{lang.Email_aldready_exists}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>
              <select class="form-control" id="lengthofService" (change)="groupContactChange($event)"
                formControlName="role" name="adminrole">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
                <!-- <option value="Others" >Others</option> -->
              </select>

              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="ShowOthers">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                  formControlName="roleName" />
                <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                    {{lang.please_enter_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editadminSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- edit for shared -->

<div class="modal fade" id="basicModaleditgroupcontactShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hidegrpadmindetailsShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="phoneNum"
                (change)="phoneFormatDynamic('phoneNumber', 'grpcontact')" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" formControlName="phoneNumber" />

              <div *ngIf="
                  grpcontact['phoneNumber'].touched &&
                  grpcontact['phoneNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" (keypress)="checkEmailValidation($event)" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                        grpcontact['email'].errors &&
                        grpcontact['email'].errors['emailExist']
                                  ">
                  {{lang.Email_aldready_exists}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>
              <select class="form-control" id="lengthofService" (change)="groupContactChange($event)"
                formControlName="role" name="adminrole">
                <option value="" disabled>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
                <!-- <option value="Others" >Others</option> -->
              </select>

              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="ShowOthers">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                  formControlName="roleName" />
                <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                    {{lang.please_enter_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetailsShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editadminSubmitShared()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- add group contact -->
<div class="modal fade" id="basicModaladdgrpcontact" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && grpcontact['adminfirstname'].errors" class="invalid-feedback">
                        <div *ngIf="grpcontact['adminfirstname'].errors['required']">First Name is required</div>
                        <div *ngIf="grpcontact['adminfirstname'].errors['minlength']">
                          First Name must be at least 3 characters
                        </div>
                        <div *ngIf="grpcontact['adminfirstname'].errors['maxlength']">
                          {{lang.First_name_must_not_exceed_20_characters}}
                        </div>
                      </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="phoneNum"
                (change)="phoneFormatDynamic('phoneNumber', 'grpcontact')" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" formControlName="phoneNumber" />

              <div *ngIf="
                  grpcontact['phoneNumber'].touched &&
                  grpcontact['phoneNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <!-- <div *ngIf="grpcontact['adminphone'].errors && grpcontact['adminphone'].errors['pattern']">Please enter valid phone number</div> -->
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" (keypress)="checkEmailValidation($event)" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                                    grpcontact['email'].errors &&
                                    grpcontact['email'].errors['emailExist']
                                  ">
                  {{lang.Email_aldready_exists}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

              <select class="form-control" id="lengthofService" formControlName="role" name="adminrole"
                (change)="groupContactChange($event)">
                <option value="null" disabled selected>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
                <!-- <option value="Others">Others</option> -->
              </select>

              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="ShowOthers">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="OtherRole" placeholder="Others"
                  formControlName="roleName" />
                <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                    {{lang.please_enter_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="addadmin()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>


<!-- Add group conatct shared -->
<div class="modal fade" id="basicModaladdgrpcontactShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Add_Group_Contact}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hidegrpadmindetailsShared()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()">
          <div class="input-wrapper row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                formControlName="firstName" />

              <div *ngIf="
                  grpcontact['firstName'].touched &&
                  grpcontact['firstName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['required']
                  ">
                  {{lang.Please_enter_first_Name}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['minlength']
                  ">
                  {{lang.First_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['firstName'].errors &&
                    grpcontact['firstName'].errors['maxlength']
                  ">
                  {{lang.First_name_must_not_exceed_20_characters}}
                </div>
              </div>
              <!-- <div *ngIf="submittedadmin && grpcontact['adminfirstname'].errors" class="invalid-feedback">
                        <div *ngIf="grpcontact['adminfirstname'].errors['required']">First Name is required</div>
                        <div *ngIf="grpcontact['adminfirstname'].errors['minlength']">
                          First Name must be at least 3 characters
                        </div>
                        <div *ngIf="grpcontact['adminfirstname'].errors['maxlength']">
                          {{lang.First_name_must_not_exceed_20_characters}}
                        </div>
                      </div> -->
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                formControlName="lastName" />

              <div *ngIf="
                  grpcontact['lastName'].touched &&
                  grpcontact['lastName'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['required']
                  ">
                  {{lang.Please_enter_Last_Name}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['minlength']
                  ">
                  {{lang.Last_Name_minimum_of_1_Character_and_without_numbers}}
                </div>
                <div *ngIf="
                    grpcontact['lastName'].errors &&
                    grpcontact['lastName'].errors['maxlength']
                  ">
                  {{lang.Last_Name_must_not_exceed_20_characters}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

              <input type="tel" class="form-control checking-field" id="phoneNum"
                (change)="phoneFormatDynamic('phoneNumber', 'grpcontact')" placeholder={{lang.Phone_Number}}
                (keypress)="numberOnly($event)" formControlName="phoneNumber" />

              <div *ngIf="
                  grpcontact['phoneNumber'].touched &&
                  grpcontact['phoneNumber'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['required']
                  ">
                  {{lang.Please_enter_phone_number}}
                </div>
                <!-- <div *ngIf="grpcontact['adminphone'].errors && grpcontact['adminphone'].errors['pattern']">Please enter valid phone number</div> -->
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['minlength']
                  ">
                  {{lang.Phone_number_minimum_of_10_digits}}
                </div>
                <div *ngIf="
                    grpcontact['phoneNumber'].errors &&
                    grpcontact['phoneNumber'].errors['maxlength']
                  ">
                  {{lang.Phone_number_maximum_of_10_digits}}
                </div>
              </div>
            </div>
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

              <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                formControlName="email" (keypress)="checkEmailValidation($event)" />
              <div *ngIf="
                  grpcontact['email'].touched && grpcontact['email'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['required']
                  ">
                  {{lang.Please_enter_email}}
                </div>
                <div *ngIf="
                                    grpcontact['email'].errors &&
                                    grpcontact['email'].errors['emailExist']
                                  ">
                  {{lang.Email_aldready_exists}}
                </div>
                <div *ngIf="
                    grpcontact['email'].errors &&
                    grpcontact['email'].errors['pattern']
                  ">
                  {{lang.Please_enter_valid_email}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

              <select class="form-control" id="lengthofService" formControlName="role" name="adminrole"
                (change)="groupContactChange($event)">
                <option value="null" disabled selected>{{lang.Select}}</option>
                <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                  {{ name.display }}
                </option>
                <!-- <option value="Others">Others</option> -->
              </select>

              <div *ngIf="grpcontact['role'].touched && grpcontact['role'].invalid" class="help-block text-danger">
                <div *ngIf="
                    grpcontact['role'].errors &&
                    grpcontact['role'].errors['required']
                  ">
                  {{lang.Please_select_role}}
                </div>
              </div>
            </div>
            <div class="col-md-6" *ngIf="ShowOthers">
              <div class="form-group">
                <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="OtherRole" placeholder={{lang.Others}}
                  formControlName="roleName" />
                <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                  <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                    {{lang.please_enter_role}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="hidegrpadmindetailsShared()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="addadminShared()">
          {{lang.Save}}
        </button>
      </div>
      <!-- <button class="btn btn-primary"  type="submit">Submit</button> -->
    </div>
  </div>
</div>

<!-- {{lang.Edit_EO}} Information -->


<div class="modal fade" id="basicModaleoedit" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_EO}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform" (ngSubmit)="addEOformDetails()">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>
              <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                formControlName="insurerName" style="text-transform: capitalize" />
              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurer_name}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                  {{lang.Insurer_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                  {{lang.Insurer_name_must_not_exceed_100_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
              <input type="text" class="form-control checking-field" id="certificateNumber"
                placeholder={{lang.Certificate}}  formControlName="certificateNo" />

              <div *ngIf="
                  eo['certificateNo'].touched && eo['certificateNo'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['certificateNo'].errors &&
                    eo['certificateNo'].errors['required']
                  ">
                  {{lang.Please_select_Certificate_Name}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

              <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                formControlName="policyNo" />

              <div *ngIf="eo['policyNo'].touched && eo['policyNo'].invalid" class="help-block text-danger">
                <div *ngIf="eo['policyNo'].errors && eo['policyNo'].errors['required']">
                  {{lang.Please_enter_Policy_Number}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="
                  eo['expiryDate'].touched && eo['expiryDate'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4"></div>
            <div class="form-group col-4">
              <!-- <button  type="submit" [hidden]="eoform.invalid" class="btn btn-primary">Save</button> -->
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editEOSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="basicModaleoeditShared" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Edit_EO}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="hidegrpadmindetailsSharedEO()"></button>
      </div>
      <div class="modal-body">
        <form class="onbordingform" [formGroup]="eoform">
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>
              <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                formControlName="insurerName" style="text-transform: capitalize" />
              <div *ngIf="eo['insurerName'].touched && eo['insurerName'].invalid" class="help-block text-danger">
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                  {{lang.Please_enter_Insurer_name}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                  {{lang.Insurer_name_must_be_atleast_3_characters}}
                </div>
                <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                  {{lang.Insurer_name_must_not_exceed_100_characters}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
              <input type="text" class="form-control checking-field" id="certificateNumber"
                placeholder={{lang.Certificate}} formControlName="certificateNo" />

              <div *ngIf="
                  eo['certificateNo'].touched && eo['certificateNo'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['certificateNo'].errors &&
                    eo['certificateNo'].errors['required']
                  ">
                  {{lang.Please_select_Certificate_Name}}
                </div>
              </div>
            </div>
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

              <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                formControlName="policyNo" />

              <div *ngIf="eo['policyNo'].touched && eo['policyNo'].invalid" class="help-block text-danger">
                <div *ngIf="eo['policyNo'].errors && eo['policyNo'].errors['required']">
                  {{lang.Please_enter_Policy_Number}}
                </div>
              </div>
            </div>
          </div>
          <div class="input-wrapper row">
            <div class="form-group col-4">
              <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

              <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                [placement]='"top"' [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
              <div *ngIf="
                  eo['expiryDate'].touched && eo['expiryDate'].invalid
                " class="help-block text-danger">
                <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                  {{lang.Please_select_expiry_date}}
                </div>
              </div>
            </div>
            <div class="form-group col-4"></div>
            <div class="form-group col-4">
              <!-- <button  type="submit" [hidden]="eoform.invalid" class="btn btn-primary">Save</button> -->
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="hidegrpadmindetailsSharedEO()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="editEOSharedSubmit()">
          {{lang.Save}}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Model For showing summary Data -->

<div class="modal fade" id="sumamryModel" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false"
  *ngIf="showfulldetails">
  <div class="modal-dialog model-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Summary_Details}}</h6>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <!-- <div>
                  <h6 class="admintitle" style="margin-top:10px;"><a class="bartitlelabel">Broker Information&nbsp;&nbsp;<i class="bi bi-info-circle"></i></a></h6>
                  </div> -->
      <div class="modal-body">
        <h6 class="admintitle panel-title" id="plancheckcollapseonegeneral"
          [attr.data-bs-target]="'#collapseonegeneral'" data-bs-toggle="collapse" aria-expanded="true"
          aria-controls="collapseonegeneral">
          {{lang.General_Details}}
        </h6>

        <div id="collapseonegeneral" class="accordion-collapse collapse show">
          <table align="left">
            <tr>
              <th>{{lang.Name}}</th>
              <th>{{lang.Role}}</th>
              <th>{{lang.Sales_Tracking_code}}</th>
              <th>{{lang.Commissions}}</th>
            </tr>
            <tbody>
              <tr>
                <td>{{ showsoleAdvisorDataResult?.name }}</td>
                <td>{{ showsoleAdvisorDataResult?.brokerType }}</td>
                <td>{{ showsoleAdvisorDataResult?.salesTrackingCode }}</td>

                <td>
                  100%
                </td>

              </tr>
            </tbody>
          </table>

        </div>
        <br />

        <h6 class="admintitle panel-title" id="plancheckcollapseonelicesne"
          [attr.data-bs-target]="'#collapseonelicesne'" data-bs-toggle="collapse" aria-expanded="true"
          aria-controls="collapseonelicesne">
        {{lang.License_Details}}
        </h6>

        <div class="row" id="collapseonelicesne" class="accordion-collapse collapse show">
          <table align="left">
            <tr>
              <th>{{lang.License}} #</th>
              <th>{{lang.Coverage}}</th>
              <th>{{lang.Province}}</th>
              <th>{{lang.Expiry_Date}}</th>
              <th>{{lang.Reminder_Days}}</th>
              <th></th>
            </tr>
            <tbody>
              <tr *ngFor="let license of showsoleAdvisorDataResult.brokerLicensedStatesAndProvinces; let i = index"
                [ngClass]="{ orange: i % 2 == 0, white: i % 2 != 0 }">
                <td>{{ license?.licenseNumber }}</td>
                <td>{{ license?.licenseCoverage }}</td>
                <td>{{ license?.stateId }}</td>
                <td>{{ license?.expiryDate | date: 'MMM dd, yyyy' }}</td>
                <td>{{ license?.reminderEmail }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
        <h6 class="admintitle panel-title" id="plancheckcollapseoneEO" [attr.data-bs-target]="'#collapseoneEO'"
          data-bs-toggle="collapse" aria-expanded="true" aria-controls="collapseoneEO">
          {{lang.E_O_Details}}
        </h6>

        <div class="row" id="collapseoneEO" class="accordion-collapse collapse show">
          <table align="left">
            <tr>
              <th>{{lang.Insurer_Name}}</th>
              <th>{{lang.Certificate}} #</th>
              <th>{{lang.Policy}} #</th>
              <th>{{lang.Expiry_Date}}</th>
            </tr>
            <tbody>
              <tr>
                <td>{{ showsoleAdvisorDataResult?.brokerEoInsurance?.insurerName }}</td>
                <td>{{ showsoleAdvisorDataResult?.brokerEoInsurance?.certificateNumber }}</td>
                <td>{{ showsoleAdvisorDataResult?.brokerEoInsurance?.policyNumber }}</td>
                <td>{{ showsoleAdvisorDataResult?.brokerEoInsurance?.expiryDate |date: 'MMM dd, yyyy'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />


        <form class="onbordingform1 form-container1 linescrollbar" [formGroup]="brokerregform">

          <div class="row mb-2">
            <div class="form-group col-3">
              <h6 class="admintitle">
                {{lang.Use_Parent_Logo}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
              </h6>

              <div class="d-flex">
                <div class="form-check form-check-inline d-flex ">
                  <input type="radio" name="parentlogo" id="parentlogoyes" value="true" formControlName="parentlogo"
                    (change)="checkParentlogo($event)" checked />
                  <label for="parentlogoyes" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                </div>
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="parentlogo" id="parentlogono" value="false" formControlName="parentlogo"
                    (change)="checkParentlogo($event)" />
                  <label for="parentlogono" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                </div>
              </div>

              <div *ngIf="
                broker['parentlogo'].touched &&
                broker['parentlogo'].invalid
              " class="help-block text-danger">
                <div *ngIf="
                  broker['parentlogo'].errors &&
                  broker['parentlogo'].errors['required']
                ">
                  {{lang.Please_select_parent_logo}}
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="form-group col-3" *ngIf="showparentlogocondition">
              <h6 class="admintitle">
                {{lang.Logo}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
              </h6>
              <!-- <label   for="adminlogo" class="adminlogo1" *ngIf="uploadlogoafter"><strong>&nbsp;Update</strong></label> -->

              <div class="uploadCorporateLogo">
                <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

                <label for="adminlogo" class="adminlogo">
                  <span *ngIf="showimagelogo">
                    <p style="font-size: 12px">
                      {{lang.Click_to_upload_LOGO_Max_300x100_px_png_jpg}}
                      <!-- Click to upload
                      <br />
                      LOGO
                      <br />
                      Max. 300x100 px .png,.jpg -->
                    </p>
                  </span>
                  <img [src]="imagedisplay" style="max-height: 50px; max-width: 100px" />
                </label>
                <input id="adminlogo" type="file" accept="image/*" style="display: none" formControlName="logo"
                  (change)="uploadadminlogo($event)" />

                <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
              </div>

              <div *ngIf="broker['logo'].touched && broker['logo'].invalid" class="help-block text-danger">
                <div *ngIf="
                  broker['logo'].errors &&
                  broker['logo'].errors['required']
                ">
                  {{lang.Please_upload_Parent_logo}}
                </div>
              </div>
            </div>
            <div class="form-group col-3">
              <h6 class="admintitle">
                {{lang.Use_Parent_Disclosure}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
              </h6>

              <div class="d-flex">
                <div class="form-check form-check-inline  d-flex">
                  <input type="radio" name="parentdisclosure" id="parentdisclosureyes" value="true"
                    formControlName="parentdisclosure" (change)="checkParentdisclosure($event)" checked />
                  <label for="parentdisclosureyes" class="parentlogo my-auto">&nbsp;&nbsp;Yes</label>
                </div>
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="parentdisclosure" id="parentdisclosureno" value="false"
                    formControlName="parentdisclosure" (change)="checkParentdisclosure($event)" />
                  <label for="parentdisclosureno" class="parentlogo my-auto">&nbsp;&nbsp;No</label>
                </div>
              </div>

              <div *ngIf="
                broker['parentdisclosure'].touched &&
                broker['parentdisclosure'].invalid
              " class="help-block text-danger">
                <div *ngIf="
                  broker['parentdisclosure'].errors &&
                  broker['parentdisclosure'].errors['required']
                ">
                  {{lang.Please_select_parent_disclosure}}
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div class="form-group col-3 " *ngIf="showparentdisclosurecondition">
              <h6 class="admintitle">
                {{lang.Disclosure_Agreement}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
              </h6>
              <div class="uploadCorporateLogo ">
                <!-- <label style="float:right;color:red"  title="Delete logo" *ngIf="uploadlogoafter" (click)="uploadadminlogoclear($event)"><i class="bi bi-trash-fill" ></i></label> -->

                <label for="Disclosure" class="Disclosure">
                  <span *ngIf="showdisclosureaggrement">
                    <p style="font-size: 12px">
                      {{lang.Click_to_upload_Disclosure_Agreement}}
                      <!-- Click to upload
                      <br />
                      Disclosure Agreement -->
                    </p>
                  </span>

                  <!-- <button (click)="openPdf()">hi</button> -->
                  <img [src]="imageDisclosure" style="max-height: 50px" data-bs-target="#disclosure" />
                </label>
                <input id="Disclosure" type="file" style="display: none" accept=".pdf,.doc"
                  formControlName="disclosureAgreement" (change)="uploadadmindisclosure($event)" />

                <!-- <input id="adminlogo1" type="file" accept="image/*" style="display: none;" formControlName="logo" (change)="uploadadminlogo1($event)"> -->
              </div>
              <div class="text-center" *ngIf="!showdisclosureaggrement" (click)="openPdf()">
                <p class="text-primary text-decoration-underline  text-center p-0 pb-1 px-1 " title={{disclosureAgg}}><u
                    style="font-size:12px;cursor:pointer">{{ disclosureAgg.substring(0, 10)
                    + '...' +
                    disclosureAgg.slice(-4)}}</u></p>
              </div>

              <div *ngIf="
                broker['disclosureAgreement'].touched &&
                broker['disclosureAgreement'].invalid
              " class="help-block text-danger">
                <div *ngIf="
                  broker['disclosureAgreement'].errors &&
                  broker['disclosureAgreement'].errors['required']
                ">
                 {{lang.Please_upload_disclosure_agreement}}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6">
              <h6 class="admintitle">
                <!-- {{lang.Do_You_Want_To_Create_A_Signup_Form}} -->
                Do you want to create an enrollment form?
                &nbsp;&nbsp;<i class="bi bi-info-circle"></i>
              </h6>

              <div class="d-flex" *ngIf="showsignupformoptions">
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="signupForm" id="signupFormyes" value="true" formControlName="signupForm"
                    (change)="signupFormCheck($event)" />
                  <label for="signupFormyes" class="signupForm my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                </div>
                <div class="form-check form-check-inline d-flex">
                  <input type="radio" name="signupForm" id="signupFormno" value="false" formControlName="signupForm"
                    (change)="signupFormCheck($event)" checked />
                  <label for="signupFormno" class="signupForm my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                </div>
              </div>
              <div *ngIf="
                broker['signupForm'].touched &&
                broker['signupForm'].invalid
              " class="help-block text-danger">
                <div *ngIf="
                  broker['signupForm'].errors &&
                  broker['signupForm'].errors['required']
                ">
                  <!-- {{lang.Please_select_signup_form}} -->
                  Please select enrollment form
                </div>
              </div>
            </div>
          </div>
        </form>
        <form class="onbordingform1 form-container1 linescrollbar" [formGroup]="formCreation">


          <div class="onbordingform" *ngIf="showaddform">

            <div class="input-wrapper row">

              <div class="form-group col-4">
                <label for="Corporation" class="Corporation">
                  <!-- {{lang.Select_Profile_for_signup}} -->
                  Select Profile for enrollment
                  <span
                    style="color: red">*</span></label>
                <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="profileName" data-live-search="true" (change)="getProfilebasedid($event)">
                  <option value="" label="">Select</option>
                  <option *ngFor="let profile of brokerProfileslist" [value]="profile.originalBrokerId">

                    {{profile.name}}({{profile.additionalData.statement}})
                  </option>
                </select>

                <div *ngIf="
                                    form['profileName'].touched && form['profileName'].invalid
                                  " class="help-block text-danger">
                  <div *ngIf="
                                      form['profileName'].errors &&
                                      form['profileName'].errors['required']
                                    ">
                    {{lang.Please_select_profile}}
                  </div>
                </div>
              </div>
            </div>


            <div class="input-wrapper row">

              <div class="form-group col-4">
                <label for="Corporation" class="Corporation">{{lang.Title}}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="formName" placeholder={{lang.Title}}
                  [(ngModel)]="formTitle" formControlName="formName" style="text-transform: capitalize" />

                <div *ngIf="
                                    form['formName'].touched && form['formName'].invalid
                                  " class="help-block text-danger">
                  <div *ngIf="
                                      form['formName'].errors &&
                                      form['formName'].errors['required']
                                    ">
                    {{lang.Please_enter_form_title}}
                  </div>
                </div>
              </div>

              <div class="form-group col-4">
                <label for="Corporation" class="Corporation">{{lang.Description}}<span style="color: red">*</span></label>
                <input type="text" class="form-control checking-field" id="formDescription" placeholder={{lang.Description}}
                  [(ngModel)]="formDescription" formControlName="formDescription" style="text-transform: capitalize" />

                <div *ngIf="
                                    form['formDescription'].touched &&
                                    form['formDescription'].invalid
                                  " class="help-block text-danger">
                  <div *ngIf="
                                      form['formDescription'].errors &&
                                      form['formDescription'].errors['required']
                                    ">
                    {{lang.Please_enter_form_description}}
                  </div>
                </div>
              </div>

              <div class="form-group col-4">
                <label for="Corporation" class="Corporation1">{{lang.Apply_Parent_Logo}}<span
                    style="color: red">*</span></label>
                <br />
                <div class="d-flex">
                  <div class="form-check form-check-inline  d-flex">
                    <input type="radio" name="formapplylogo" id="formapplylogoyes" value="true"
                      formControlName="formapplylogo" (change)="checkParentFormlogo($event)" />
                    <label for="formapplylogoyes" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.Yes}}</label>
                  </div>
                  <div class="form-check form-check-inline d-flex">
                    <input type="radio" name="formapplylogo" id="formapplylogono" value="false"
                      formControlName="formapplylogo" (change)="checkParentFormlogo($event)" />
                    <label for="formapplylogono" class="parentlogo my-auto">&nbsp;&nbsp;{{lang.No}}</label>
                  </div>
                </div>

                <div *ngIf=" form['formapplylogo'].touched && form['formapplylogo'].invalid"
                  class="help-block text-danger">
                  <div *ngIf=" form['formapplylogo'].errors && form['formapplylogo'].errors['required']">
                    {{lang.Please_select_logo_type}}
                  </div>
                </div>


                <div class="form-group " *ngIf="showparentformlogocondition">
                  <label for="Corporation" class="Corporation">{{lang.Logo}}</label>
                  <input type="file" class="form-control checking-field" id="formlogo" placeholder="logo"
                    formControlName="formlogo" (change)="uploadadminFormlogo($event)" />



                  <div *ngIf="form['formlogo'].touched && form['formlogo'].invalid" class="help-block text-danger">
                    <div *ngIf="form['formlogo'].errors && form['formlogo'].errors['required']">
                      {{lang.Please_choose_form_logo}}
                    </div>
                  </div>
                </div>


                <div *ngIf="showParentLogoDisplay" class="uploadCorporateLogo">

                  <label for="adminformlogo" class="adminformlogo" id="fileSaver">
                    <img [src]="displaylogo" style="max-height: 50px;max-width:100px" />
                  </label>

                </div>
              </div>

            </div>

            <ng-container *ngIf="showaddplans">

            <app-common-plans
              #advisorAdd
              [isAdvisor]="true"
              [viewPlan]="false"
              [advisorPackages]="productsArray"
              [allplansArray]="allplansArray"
              (submitTriggered)="addform1()"
              [editFormPricingOptions]=""
              [selectedPlanLevels]="[]"
              >
            </app-common-plans>
            
            <div class="input-wrapper row border border-dark mx-1 mt-3 linescrollbar"
              style="font-size: 12px; width:75%;max-height:350px;overflow-y: scroll;" *ngIf="showPlans && false">

              <div *ngFor="let product of productsArray; let i=index" class="mt-2">

                <div class="display-center">
                  <div class="border border-dark text-center text-light d-flex align-items-center mt-1 py-1 rounded row"
                    style="width:430px;" [ngStyle]="{ 'background-color': product.published ? '#515151' : '#dc3545' }">

                    <span class="my-auto col-1 ">
                      <input type="checkbox" id="package{{product.id}}"
                        [disabled]="allplansArray[product.name]?.disabled===true"
                        [checked]="allplansArray[product.name]?.packageCheckbox===true"
                        (change)="toggleAllPlans(product.name,product.id, $event)" />
                    </span>
                    <div class="my-auto mb-1 col-10 text-center">
                      <span class="my-auto mb-1 col-10 text-center">{{ product.name }}&nbsp;<i
                          *ngIf="!product.published && role==='ADMINISTRATOR'" class="bi bi-info-circle text-light "
                          title="Unpublished"></i></span>
                    </div>
                    <div *ngIf="role==='ADMINISTRATOR'"
                      title="{{getTextForTooltip1(product.published,product.restrict)}}"
                      [ngStyle]=" { 'border-color' : getColorForPlans1(product.published,product.restrict) }"
                      class="outer my-auto ms-3 col-2" data-bs-toggle="">
                      <span class="inner"
                        [ngStyle]="{ 'background': getColorForPlans1(product.published,product.restrict) }"></span>
                    </div>
                  </div>
                </div>

                <div class="display-center mt-3 mb-4 flex-wrap">
                  <div *ngFor="let plans of product.parents| keyvalue; let k=index">
                    <div
                      class="mt-1 mx-1 border border-dark text-light text-center d-flex align-items-center mt-1 py-1 px-0 rounded row"
                      *ngIf="isParentsGreaterThanOne(product.parents)" style="background-color: #515151; width:210px">

                      <span class="my-auto col-1">
                        <input type="checkbox" [disabled]="allplansArray[product.name][plans.key]?.disabled===true"
                          [checked]="allplansArray[product.name][plans.key]?.checked===true"
                          (change)="planKeyCheckbox(product.name,plans.key,plans.value[0].parentId,$event)" />
                      </span>
                      <span class="my-auto mb-1 col-9 text-center">{{ plans.key }}</span>
                    </div>
                    <div
                      [ngClass]="{'display-center': !isParentsGreaterThanOne(product.parents), 'flex-wrap': !isParentsGreaterThanOne(product.parents)}">
                      <div *ngFor="let plan of plans.value">
                        <div [style.background-color]="plan.backgroundColor ? plan.backgroundColor : '#5E152E'" class="mt-2 mx-1 border border-dark text-center text-light rounded d-flex
                        align-items-center gap-1 row py-1 rounded" style="width:210px ">
                          <!-- *ngIf="plan.parentId != null" -->
                          <div class="my-auto col-1">
                            <input type="checkbox" id="planCheckbox{{plan.id}}"
                              [checked]="allplansArray[product.name][plan.name]?.planCheckbox===true"
                              [disabled]="allplansArray[product.name][plan.name]?.disabled===true"
                              (change)="planCheckbox(product.name,plans.key,plans.value[0].parentId,plan.name,plan.id,$event)" />
                          </div>
                          <div class="my-auto col-9 mb-1  " style="font-size:12px">
                            <span>{{ plan.name }}</span>

                          </div>
                          <div *ngIf="role==='ADMINISTRATOR'"
                            title="{{getTextForTooltip(plan.published.data[0],plan.restrict)}}"
                            [ngStyle]=" { 'border-color' : getColorForPlans(plan.published.data[0],plan.restrict) }"
                            class="outer my-auto col-2" data-bs-toggle="">
                            <span class="inner"
                              [ngStyle]="{ 'background': getColorForPlans(plan.published.data[0],plan.restrict) }"></span>
                          </div>

                        </div>
                        <div class="mt-2 mx-1" *ngIf="showPricing && plan.id==5">
                          <label class="Corporation">{{lang.Pricing }}</label>
                          <select type="" class="form-control1 py-1 text-dark" id="pricingOptions" placeholder="Select"
                            (change)="selectPricingOptions" formControlName="pricingOptions">
                            <option selected value="">{{lang.Select}}</option>
                            <option *ngFor="let option of pricingOptions" [value]="option.key">
                              {{ option.display }}
                            </option>
                          </select>
                        </div>
                        <div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <hr style="    height: 2px;
                background-color: black;">
              </div>

            </div>

            <div *ngIf="plansError" class="text-danger text-end" style="font-size:12px">
              {{lang.Please_select_atleast_one_plan}}
            </div>
            <div class="text-white d-flex gap-1 justify-content-end  mt-1  mb-5">
              <button type="button" class="btn cancelBtn " (click)="cancelSignup()">
                {{lang.Cancel}}
              </button>
              <!-- <button #scrollTarget id="scrollTarget" type="submit" [disabled]="formCreation.invalid"
                (click)="addform1()" class="btn btn-primary">
                {{lang.Save}}
              </button> -->
              <button #scrollTarget id="scrollTarget" type="submit" [disabled]="formCreation.invalid"
                (click)="advisorAdd.addForm()" class="btn btn-primary">
                {{lang.Save}}
              </button>
            </div>
            
            </ng-container>



          </div>
          <div class="row" id="SAveFORM">
            <div class="form-group col-12" style="margin-bottom: 3px">
              <div style="direction: ltr; width: 100%">
                <div class="row pb-1">
                  <div class="form-group col-12">
                    <table align="left" *ngIf="showFormsDetails">
                      <tr>
                        <th>{{lang.Type}}</th>
                        <th>{{lang.Profile}}</th>
                        <th>{{lang.Title}}</th>
                        <th>{{lang.Description}}</th>

                        <th></th>
                      </tr>
                      <tbody>
                        <tr *ngFor="
                            let broker of brokerFormData;
                            let i = index
                          " [ngClass]="{
                            orange: i % 2 == 0,
                            white: i % 2 != 0
                          }">
                          <td>
                            <select class="form-control" id="Signupformtype" placeholder="Select"
                              [(ngModel)]="broker.formType" [ngModelOptions]="{ standalone: true }" [disabled]="
                                isEditableForm || enableEditIndexForm != i
                              " (change)="selectFormname($event)">
                              <option value="" disabled>Select</option>
                              <option *ngFor="let name of formType" [value]="name.label">
                                {{ name.display }}
                              </option>
                            </select>
                          </td>
                          <td>

                            <!-- <div class="form-control checking-field">
                              {{broker.profiles[0].name}}({{broker.profiles[0].additionalData.code}})
                            </div> -->


                            <select class="form-control" id="Signupformtype" placeholder="Select"
                              [(ngModel)]="broker.profile" [ngModelOptions]="{ standalone: true }" [disabled]="
                                isEditableForm || enableEditIndexForm != i
                              " (change)="getProfilebasedid($event)">
                              <option value="" disabled>{{lang.Select}}</option>

                              <option *ngFor="let profile of brokerProfileslist" selected
                                [value]="profile.originalBrokerId">
                                {{profile.name}}({{profile.additionalData.statement}})

                              </option>
                            </select>
                          </td>
                          <td>
                            <input type="text" class="form-control checking-field" id="FormName" placeholder="formName"
                              [(ngModel)]="broker.name" [ngModelOptions]="{ standalone: true }"
                              style="text-transform: capitalize" [disabled]="
                                isEditableForm || enableEditIndexForm != i
                              " />
                          </td>
                          <td>
                            <input type="text" class="form-control checking-field" id="Description"
                              placeholder="Description" [(ngModel)]="broker.description"
                              [ngModelOptions]="{ standalone: true }" style="text-transform: capitalize" [disabled]="
                                isEditableForm || enableEditIndexForm != i
                              " />
                          </td>
                          <!-- <td> -->


                          <!-- <img [src]="showLogoDisplayList(broker) " style="max-height: 50px;max-width:100px" /> -->

                          <!-- <input
                                type="file"
                                class="form-control checking-field"
                                id="file"
                                placeholder="file"  [(ngModel)]="broker.logo" [ngModelOptions]="{standalone: true}"  style="text-transform: capitalize;" [disabled]="isEditableForm || enableEditIndexForm != i"/> -->
                          <!-- </td> -->

                          <td style="display: flex; margin-top: 10px">
                            <button class="btn btn-default editpencil" data-bs-toggle="modal"
                              (click)="
                                editadvisorformDetails($event, i, broker)
                              " *ngIf="enableEditIndexForm != i">
                              <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                              class="btn btn-default deleteicon" (click)="deleteForm(broker, i)"
                              *ngIf="enableEditIndexForm != i">
                              <i class="bi bi-trash-fill"></i>
                            </button>
                            <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModalFormedit" (click)="editadvisorformDetails($event, i, broker)" *ngIf="enableEditIndexForm != i">Edit</button>&nbsp;
  <button class="brokertablestatus" style="color:red" (click)="deleteForm(broker,i)" *ngIf="enableEditIndexForm != i">Delete</button> -->
                            <button class="brokertablestatus" style="color: green" *ngIf="
                                !isEditableForm && enableEditIndexForm == i
                              " (click)="saveForm(broker, i)">
                              Save12</button>&nbsp;
                            <button class="brokertablestatus" style="color: red" *ngIf="
                                !isEditableForm && enableEditIndexForm == i
                              " (click)="cancelFormEdit($event, i)">
                              Cancel12
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <button *ngIf="showFormsDetails" class="btn btn-primary addgroupadmininfo" type="button"
                  (click)="addextraform()">
                  {{lang.Add_More}}
                </button>
              </div>
            </div>
          </div>
        </form>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closesummarydetails()">
          {{lang.Close}}
        </button>
        <button type="button" class="btn btn-primary" (click)="submitbasicFormInfo()" *ngIf="showsubmitform">
          {{lang.Save}}
        </button>
        <!-- <button type="button" class="btn btn-primary" (click)="viewfulldetailsofBroker('finalSummaryBrookerDataid')">
          {{lang.View_Full_Details}}
        </button> -->
      </div>
    </div>
  </div>
</div>

<!-- Model For Selecting Sumamry Details -->
<div class="modal fade" id="addCustomFormDetails" tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Summary_Details}}</h6>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <!-- <div>
                  <h6 class="admintitle" style="margin-top:10px;"><a class="bartitlelabel">Broker Information&nbsp;&nbsp;<i class="bi bi-info-circle"></i></a></h6>
                  </div> -->
      <div class="modal-body">
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closesummarydetails()">
            {{lang.Close}}
          </button>
          <button type="button" class="btn btn-primary" (click)="viewfulldetailsofBroker('finalSummaryBrookerDataid')">
            {{lang.View_Full_Details}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="QCproviance">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">
        <!-- <div class="col-1">
                  <i class="fa fa-info-circle dependentchildinfo text-white" aria-hidden="true"></i>
                </div> -->
        <div class="col-10 text-white text-center">{{lang.Service_Unavailability}}</div>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>

      </div>
      <div class="model-body ms-3 mt-2">
        <p>
          {{lang.service_not_available_in_Quebec_presently_Please_check_back_in_2025}}
        </p>
      </div>
      <div class="modal-footer">
        <button class="btn btn-dark buttonSizeNDColor backgroundColor" style="font-size: 14px; border-radius: 5px"
          data-bs-dismiss="modal">
          <strong style="color: black" (click)="closePopup('QCproviance')">{{lang.Close}}</strong>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="disclosure">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header modalPopupHeaderAndButtonBgColor d-flex headerBottomRadius10px">
        <!-- <div class="col-1">
                  <i class="fa fa-info-circle dependentchildinfo text-white" aria-hidden="true"></i>
                </div> -->
        <div class="col-10 text-white text-center">{{lang.Disclosure_Agreement}}</div>
        <i class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"></i>

      </div>
      <div class="model-body ms-3 mt-2">
        <pdf-viewer *ngIf=true id="pdf-viewer" [src]="imagedisplaypdf" [render-text]="true"
          [original-size]="false"></pdf-viewer>
      </div>
      <div class="modal-footer">
        <button class="btn" style="font-size: 14px; border-radius: 5px" data-bs-dismiss="modal"
          (click)="closePopup('disclosure')">
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>
<div class="modal" role="dialog" data-bs-backdrop="static" aria-labelledby="modal-label" id="BrokerSharedNewDetails"
  tabindex="-1">
  <div class="modal-dialog model-lg modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">{{lang.Broker_Details}}</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closesharedmodel()"></button>
      </div>
      <!-- <div>
                  <h6 class="admintitle" style="margin-top:10px;"><a class="bartitlelabel">Broker Information&nbsp;&nbsp;<i class="bi bi-info-circle"></i></a></h6>
                  </div> -->
      <div class="modal-body">


        <form class="onbordingform form-container linescrollbar" [formGroup]="brokerregform">

          <div class="form-group col-6">
            <label for="Corporation" class="Corporation">{{lang.Select_broker_status}}</label>
            <div class="d-flex">
              <div class="form-check form-check-inline d-flex">
                <input type="radio" name="brokerStatus" id="brokerStatusnew" value="false"
                  formControlName="brokerStatus" (change)="sharedBrokerType($event)" />
                <label for="brokerStatusnew" class="brokerShare my-auto">&nbsp;&nbsp;{{lang.New}}</label>
              </div>
              <div class="form-check form-check-inline d-flex ">
                <input type="radio" name="brokerStatus" id="brokerStatusexist" value="true"
                  formControlName="brokerStatus" (change)="sharedBrokerType($event)" checked />
                <label for="brokerStatusexist" class="brokerShare my-auto">&nbsp;&nbsp;{{lang.Existing}}</label>
              </div>

            </div>

            <div *ngIf="
              broker['brokerStatus'].touched &&
              broker['brokerStatus'].invalid
            " class="help-block text-danger">
              <div *ngIf="
                broker['brokerStatus'].errors &&
                broker['brokerStatus'].errors['required']
              ">
                Please {{lang.Select_broker_status}}
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
          <div *ngIf="showSharedAdvisorData">
            <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
              <div class="form-group col-md-6">
                <label for="Corporation" class="Corporation">{{lang.Brokerage_Parent_Advisor}}</label>

                <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="ParentbrokerName" data-live-search="true" (change)="getBrokerlistData($event)">
                  <option value="" label="">{{lang.Select}}</option>
                  <option *ngFor="let broker of allBrokersUnique" [value]="broker.id">
                    <!-- {{ broker.fullName }} -->
                    {{ broker.name }}-{{ broker.brokerType }}-{{
                      broker.salesTrackingCode
                      }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                    <!-- {{broker.salesTrackingCodeWithStatement}} -->
                  </option>
                </select>

                <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
          </div> -->
              </div>
              <div class="form-group col-md-6">
                <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>
                <!-- <select
            class="form-control"
            id="brokerType"
            placeholder="Select"
            formControlName="brokerType">
            <option value="">Select</option>
            <option value="ADVISOR">Advisor</option>
            <option value="ASSOCIATION">Association</option>
            <option value="BROKERAGE">Brokerage</option>
            <option value="TPA/MGA">TPA/MGA</option>
            </select> -->

                <select class="form-control" id="brokerType" placeholder="Select"
                  (change)="checkbrokertype(brokername.value)" #brokername formControlName="brokerType">
                  <option value="">{{lang.Select}}</option>

                  <option *ngFor="let name of brokerType" [value]="name.label">
                    {{ name.display }}
                  </option>
                </select>
                <div *ngIf="
                broker['brokerType'].touched &&
                broker['brokerType'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['brokerType'].errors &&
                  broker['brokerType'].errors['required']
                ">
                    {{lang.Please_select_Role}}
                  </div>
                </div>
              </div>
            </div>
            <div class="input-wrapper row">
              <div class="form-group col-md-6">
                <label for="Corporation" class="Corporation">{{lang.Name_of_Broker}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="nameofcorporation"
                  placeholder="Name of Broker" style="text-transform: capitalize" formControlName="brokersName"
                  (change)="checkAdvsiorNameExist()" />
                <div *ngIf="
                broker['brokersName'].touched &&
                broker['brokersName'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['brokersName'].errors &&
                  broker['brokersName'].errors['required']
                ">
                    {{lang.Please_enter_broker_name}}
                  </div>
                  <div *ngIf="
                  broker['brokersName'].errors &&
                  broker['brokersName'].errors['minlength']
                ">
                    <!-- {{lang.Broker_name_must_be_atleast_3_characters}} -->
                     Broker Name must be minimum of 1 character
                  </div>
                  <div *ngIf="
                  broker['brokersName'].errors &&
                  broker['brokersName'].errors['maxlength']
                ">
                    {{lang.Broker_name_must_not_exceed_255_characters}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-6" *ngIf="showBusinessnumber">
                <label for="Corporation" class="Corporation">{{lang.Business_Number}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="businessnumber" placeholder="Business Number"
                  formControlName="businessnumber" />
                <div *ngIf="
                broker['businessnumber'].touched &&
                broker['businessnumber'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['businessnumber'].errors &&
                  broker['businessnumber'].errors['required']
                ">
                    {{lang.Please_enter_business_number}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Phone}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="primaryPhone"
                  (change)="phoneFormat('primaryPhone')" placeholder={{lang.Phone}} formControlName="primaryPhone"
                  (keypress)="numberOnly($event)" />
                <div *ngIf="
                broker['primaryPhone'].touched &&
                broker['primaryPhone'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['primaryPhone'].errors &&
                  broker['primaryPhone'].errors['required']
                ">
                    {{lang.Please_enter_phone_number}}
                  </div>
                  <div *ngIf="
                  broker['primaryPhone'].errors &&
                  broker['primaryPhone'].errors['minlength']
                ">
                    {{lang.Phone_number_minimum_of_10_digits}}
                  </div>
                  <div *ngIf="
                  broker['primaryPhone'].errors &&
                  broker['primaryPhone'].errors['maxlength']
                ">
                    {{lang.Phone_number_maximum_of_10_digits}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Secondary_Phone}}</label>

                <input type="text" class="form-control checking-field" (change)="phoneFormat('secondaryPhone')"
                  id="secondaryPhone" placeholder={{lang.Secondary_Phone}} formControlName="secondaryPhone"
                  (keypress)="numberOnly($event)" />
                <div *ngIf="
                broker['secondaryPhone'].touched &&
                broker['secondaryPhone'].invalid
              " class="help-block text-danger">
                  <!-- <div *ngIf="broker['primaryPhone'].errors && broker['primaryPhone'].errors['required']">Please enter Phone number</div> -->
                  <div *ngIf="
                  broker['secondaryPhone'].errors &&
                  broker['secondaryPhone'].errors['minlength']
                ">
                    {{lang.Phone_number_minimum_of_10_digits}}
                  </div>
                  <div *ngIf="
                  broker['secondaryPhone'].errors &&
                  broker['secondaryPhone'].errors['maxlength']
                ">
                    {{lang.Phone_number_maximum_of_10_digits}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>
                <!-- <input
            type="text"
            class="form-control checking-field"
            id="email"
            placeholder="Primary Email"
            formControlName="primaryEmail"
            (keypress)="checkEmailValidation($event)"/> -->

                <input type="text" class="form-control checking-field" type="text" id="email"
                  placeholder={{lang.Email}} formControlName="primaryEmail"
                  (keypress)="textChangeToLowerCase('primaryEmail')" />

                <div *ngIf="
                broker['primaryEmail'].touched &&
                broker['primaryEmail'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['primaryEmail'].errors &&
                  broker['primaryEmail'].errors['required']
                ">
                    {{lang.Please_enter_email}}
                  </div>
                  <div *ngIf="
                  broker['primaryEmail'].errors &&
                  (broker['primaryEmail'].errors['pattern'] ||
                    broker['primaryEmail'].errors['invalidEmail'])
                ">
                    {{lang.Please_enter_valid_email}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Secondary_Email}}</label>

                <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Secondary_Email}}
                  formControlName="secondaryEmail" (keypress)="textChangeToLowerCase('secondaryEmail')" />

                <div *ngIf="
                broker['secondaryEmail'].touched &&
                broker['secondaryEmail'].invalid
              " class="help-block text-danger">
                  <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                  <div *ngIf="
                  broker['secondaryEmail'].errors &&
                  broker['secondaryEmail'].errors['pattern']
                ">
                     {{lang.Please_enter_valid_email}}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-md-4">
                <label for="Corporation" class="Corporation">{{lang.Third_Email}}</label>

                <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Third_Email}}
                  formControlName="thirdEmail" (keypress)="textChangeToLowerCase('thirdEmail')" />

                <div *ngIf="
                broker['thirdEmail'].touched &&
                broker['thirdEmail'].invalid
              " class="help-block text-danger">
                  <!-- <div *ngIf="broker['primaryEmail'].errors && broker['primaryEmail'].errors['required']">Please enter email</div> -->
                  <div *ngIf="
                  broker['thirdEmail'].errors &&
                  broker['thirdEmail'].errors['pattern']
                ">
                   {{lang.Please_enter_valid_email}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="Corporation" class="Corporation">{{lang.Street_Address}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="Street Address" placeholder={{lang.Street_Address}}
                  formControlName="streetAddress" />
                <div *ngIf="
                broker['streetAddress'].touched &&
                broker['streetAddress'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['streetAddress'].errors &&
                  broker['streetAddress'].errors['required']
                ">
                    {{lang.Please_enter_street_address_name}}
                  </div>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="Corporation" class="Corporation">{{lang.Street_Address_Line_2}}</label>

                <input type="text" class="form-control checking-field" id="StreetAddreess2"
                  placeholder={{lang.Street_Address_Line_2}} formControlName="streetAddress2" />
              </div>
            </div>

            <div class="row">
              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.City}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="city" placeholder={{lang.City}}
                  style="text-transform: capitalize" formControlName="city" />
                <!-- (keypress)="alphaNumarics($event)" -->
                <div *ngIf="broker['city'].touched && broker['city'].invalid" class="help-block text-danger">
                  <div *ngIf="
                  broker['city'].errors &&
                  broker['city'].errors['required']
                ">
                    {{lang.Please_enter_city_name}}
                  </div>
                  <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                </div>
              </div>

              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Country}}<span style="color: red">*</span></label>

                <select class="form-control" id="country" placeholder="Country" formControlName="country">
                  <option value="">{{lang.Select}}</option>
                  <option value="canada" selected>Canada</option>
                  <!-- <option value="usa">USA</option> -->

                  <!-- <option
              *ngFor="let name of configprovinceres"
              [value]="name.shortName"
            >
              {{ name.shortName }}
            </option> -->
                </select>
                <div *ngIf="
                broker['country'].touched && broker['country'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['country'].errors &&
                  broker['country'].errors['required']
                ">
                    {{lang.Please_select_country}}
                  </div>
                  <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                </div>
              </div>

              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

                <select class="form-control" id="Province" placeholder="Province" formControlName="Province"
                  (change)="provincelist($event)">
                  <option value="">{{lang.Select}}</option>

                  <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                    {{ name.shortName }}
                  </option>
                </select>

                <div *ngIf="
                broker['Province'].touched && broker['Province'].invalid
              " class="help-block text-danger">
                  <div *ngIf="
                  broker['Province'].errors &&
                  broker['Province'].errors['required']
                ">
                    {{lang.Please_select_province}}
                  </div>
                  <!-- <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['minlength']">Corporation name should be 3 character</div>
          <div *ngIf="broker['streetAddress'].errors && broker['streetAddress'].errors['maxlength']">Corporation name must not exceed 30 characters</div> -->
                </div>
              </div>
              <div class="form-group col-md-3">
                <label for="Corporation" class="Corporation">{{lang.Postal_Code}}<span style="color: red">*</span></label>

                <input type="text" class="form-control checking-field" id="postalcode" placeholder={{lang.Postal_Code}}
                  onkeyup="this.value = this.value.toUpperCase();" formControlName="postalCode"
                  (input)="changeTextToUppercase('postalcode', $event)" />
                <div *ngIf="broker['postalCode'].touched" class="help-block text-danger">
                  <div *ngIf="
                  broker['postalCode'].errors &&
                  broker['postalCode'].errors['required']
                ">
                    {{lang.Please_enter_postal_code}}
                  </div>
                  <div *ngIf="
                  invalidpostalcodeprivince ||
                  (broker['postalCode'].touched &&
                    broker['postalCode'].hasError('invalidPostalCode'))
                ">
                    {{lang.Please_enter_valid_postal_code}}
                  </div>
                </div>
              </div>
            </div>

            <!-- Add Group Contacts -->
            <div class="row">
              <div class="form-group col-12 pt-2">
                <h6 class="admintitle">
                  {{lang.Group_Contacts}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6>
              </div>
            </div>

            <form class="onbordingform" [formGroup]="adminform" (ngSubmit)="addadmin()" *ngIf="addadminform">
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.First_Name}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="firstName" placeholder={{lang.First_Name}}
                      formControlName="firstName" style="text-transform: capitalize" />

                    <div *ngIf="
                    grpcontact['firstName'].touched &&
                    grpcontact['firstName'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      grpcontact['firstName'].errors &&
                      grpcontact['firstName'].errors['required']
                    ">
                        {{alng.Please_enter_first_Name}}
                      </div>
                      <div *ngIf="
                      grpcontact['firstName'].errors &&
                      grpcontact['firstName'].errors['minlength']
                    ">
                        {{lang.First_Name_minimum_of_1_Character_and_without_numbers}}
                      </div>
                      <div *ngIf="
                      grpcontact['firstName'].errors &&
                      grpcontact['firstName'].errors['maxlength']
                    ">
                        {{lang.First_name_must_not_exceed_20_characters}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Last_Name}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="lastName" placeholder={{lang.Last_Name}}
                      style="text-transform: capitalize" formControlName="lastName" />

                    <div *ngIf="
                    grpcontact['lastName'].touched &&
                    grpcontact['lastName'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      grpcontact['lastName'].errors &&
                      grpcontact['lastName'].errors['required']
                    ">
                        {{lang.Please_enter_Last_Name}}
                      </div>
                      <div *ngIf="
                      grpcontact['lastName'].errors &&
                      grpcontact['lastName'].errors['minlength']
                    ">
                        {{lang.Last_Name_minimum_of_1_Character_and_without_numbers}}
                      </div>
                      <div *ngIf="
                      grpcontact['lastName'].errors &&
                      grpcontact['lastName'].errors['maxlength']
                    ">
                        {{lang.Last_Name_must_not_exceed_20_characters}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Phone_Number}}<span style="color: red">*</span></label>

                    <input type="tel" class="form-control checking-field" id="phoneNum" placeholder={{lang.Phone_Number}} (change)="
                    phoneFormatForGroupCont(adminform, 'phoneNumber')
                  " formControlName="phoneNumber" />

                    <div *ngIf="
                    grpcontact['phoneNumber'].touched &&
                    grpcontact['phoneNumber'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      grpcontact['phoneNumber'].errors &&
                      grpcontact['phoneNumber'].errors['required']
                    ">
                        {{lang.Please_enter_Phone_Number}}
                      </div>
                      <div *ngIf="
                      grpcontact['phoneNumber'].errors &&
                      grpcontact['phoneNumber'].errors['minlength']
                    ">
                        {{lang.Phone_number_minimum_of_10_digits}}
                      </div>
                      <div *ngIf="
                      grpcontact['phoneNumber'].errors &&
                      grpcontact['phoneNumber'].errors['maxlength']
                    ">
                        {{lang.Phone_number_maximum_of_10_digits}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Email}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="email" placeholder={{lang.Email}}
                      formControlName="email" (keypress)="checkEmailValidation($event)" />
                    <div *ngIf="
                    grpcontact['email'].touched &&
                    grpcontact['email'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      grpcontact['email'].errors &&
                      grpcontact['email'].errors['required']
                    ">
                        {{lang.Please_enter_email}}
                      </div>
                      <div *ngIf="
                      grpcontact['email'].errors &&
                      grpcontact['email'].errors['pattern']
                    ">
                        {{lang.Please_enter_valid_email}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Role}}<span style="color: red">*</span></label>

                    <select (change)="groupContactChange($event)" class="form-control" id="adminrole"
                      formControlName="role" placeholder={{lang.Role}}>
                      <option value="null" selected>{{lang.Select}}</option>
                      <option *ngFor="let name of advisorGroupContact" [value]="name.key">
                        {{ name.display }}
                      </option>
                      <!-- <option value="Others">Others</option> -->
                    </select>

                    <div *ngIf="
                    grpcontact['role'].touched &&
                    grpcontact['role'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      grpcontact['role'].errors &&
                      grpcontact['role'].errors['required']
                    ">
                        {{lang.Please_select_role}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4" *ngIf="ShowOthers">
                  <div class="form-group">
                    <label for="Corporation" class="Corporation">{{lang.Others}}<span style="color: red">*</span></label>

                    <input type="text" class="form-control checking-field" id="OtherRole" placeholder="Others"
                      formControlName="roleName" />
                    <div *ngIf="
                    grpcontact['roleName'].touched &&
                    grpcontact['roleName'].invalid
                  " class="help-block text-danger">
                      <div *ngIf="
                      grpcontact['roleName'].errors &&
                      grpcontact['roleName'].errors['required']
                    ">
                        {{lang.please_enter_role}}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-12 pt-2">
                  <button [hidden]="adminform.invalid" type="submit" class="btn btn-primary">
                    {{lang.Save}}
                  </button>
                </div>
              </div>
            </form>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group" style="margin-bottom: 3px">
                  <div style="overflow: auto; direction: ltr; width: 100%">
                    <table align="left" *ngIf="showaddadmin">
                      <tr>
                        <th>{{lang.First_Name}}</th>
                        <th>{{lang.Last_Name}}</th>
                        <th>{{lang.Phone_Number}}</th>
                        <th>{{lang.Email}}</th>
                        <th>{{lang.Role}}</th>
                        <th></th>
                      </tr>
                      <tbody>
                        <tr *ngFor="let admin of adminData; let i = index" [ngClass]="{
                        orange: i % 2 == 0,
                        white: i % 2 != 0
                      }">
                          <td>{{ admin.firstName }}</td>
                          <td>{{ admin.lastName }}</td>
                          <td>{{ admin.phoneNumber |phoneFormat }}</td>
                          <td>{{ admin.email }}</td>
                          <td>
                            <span *ngIf="admin.role == 'ADVISOR_EXECUTIVE'">{{lang.Executive}}</span>
                            <span *ngIf="admin.role == 'ADVISOR_ADMINISTRATOR'">{{lang.Administrator}}</span>
                            <span *ngIf="admin.role == 'ADVISOR_CONTACT'">{{lang.Support}}</span>
                            <span *ngIf="admin.role == 'ADVISOR_OTHERS'">{{
                              admin.roleName
                              }}</span>
                          </td>

                          <td style="text-align: right; display: flex">
                            <button class="btn btn-default editpencil" data-bs-toggle="modal"
                              data-bs-target="#basicModaleditgroupcontactShared" (click)="editadminShared(admin, i)">
                              <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                              class="btn btn-default deleteicon" (click)="deleteadmin(admin, i)">
                              <i class="bi bi-trash-fill"></i>
                            </button>

                            <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleditgroupcontact"(click)="editadmin(admin,i)">Edit</button>&nbsp;
                    <button class="brokertablestatus" style="color:red" (click)="deleteadmin(admin,i)">Delete</button> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <button *ngIf="showaddadmin" class="btn btn-primary addgroupadmininfo" type="button"
                  data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontactShared"
                  (click)="hidegrpadmindetailsShared1()">
                  {{lang.Add_More}}
                </button>
              </div>
            </div>
            <!-- LinceInformation -->
            <div class="row">
              <div class="form-group col-12">
                <h6 class="admintitle">
                  {{lang.License_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6>
              </div>
            </div>

            <form class="onbordingform" [formGroup]="licenseform" (ngSubmit)="addlicense()" *ngIf="addlicenseform">
              <div class="input-wrapper row">
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.License}} #<span style="color: red">*</span></label>

                  <input type="text" class="form-control checking-field" id="licenseNumber" placeholder="License Number"
                    formControlName="licenseNo" style="text-transform: capitalize" />

                  <div *ngIf="
                  f['licenseNo'].touched && f['licenseNo'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['required']
                  ">
                      {{lang.Please_enter_license_number}}
                    </div>
                    <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['minlength']
                  ">
                      {{lang.License_number_must_be_atleast_3_characters}}
                    </div>
                    <div *ngIf="
                    f['licenseNo'].errors &&
                    f['licenseNo'].errors['maxlength']
                  ">
                      {{lang.License_number_must_not_exceed_100_characters}}s
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Coverage}}<span style="color: red">*</span></label>

                  <select class="form-control" formControlName="licenseCoverage">
                    <option value="" selected>{{lang.Select}}</option>
                    <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                      {{ name.display }}
                    </option>
                  </select>
                  <!-- <select class="form-control" formControlName="licenseCoverage1">
            <option value="" Selected>Select</option>
          </select> -->

                  <div *ngIf="
                  f['licenseCoverage'].touched &&
                  f['licenseCoverage'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    f['licenseCoverage'].errors &&
                    f['licenseCoverage'].errors['required']
                  ">
                      {{lang.Please_select_license_coverage}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Province}}<span style="color: red">*</span></label>

                  <select class="form-control" id="state" placeholder="state" formControlName="state"
                    (change)="insuranceprovincelist($event)">
                    <option value="" label="" disabled>{{lang.Select}}</option>
                    <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                      {{ name.shortName }}
                    </option>
                  </select>

                  <div *ngIf="f['state'].touched && f['state'].invalid" class="help-block text-danger">
                    <div *ngIf="
                    f['state'].errors && f['state'].errors['required']
                  ">
                      {{lang.Please_select_province}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}<span style="color: red">*</span></label>

                  <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" [min]="minDate"
                    formControlName="expiryDate" [placement]='"top"' bsDatepicker [minDate]="todayDate"
                    [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" (onShown)="disableScrolling()"
                    (onHidden)="enableScrolling()" />
                  <div *ngIf="f['expiryDate'].touched && f['expiryDate'].invalid" class="help-block text-danger">
                    <div *ngIf="
                    f['expiryDate'].errors &&
                    f['expiryDate'].errors['required']
                  ">
                      {{lang.Please_select_expiry_date}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Reminder_Days}}<span style="color: red">*</span></label>
                  <input type="text" class="form-control checking-field" id="remainder_days" value="30"
                    placeholder={{lang.Reminder_Days}} (keypress)="numberOnly($event)" formControlName="reminderMailDays"
                    style="text-transform: capitalize" />

                  <div *ngIf="
                  f['reminderMailDays'].touched &&
                  f['reminderMailDays'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    f['reminderMailDays'].errors &&
                    f['reminderMailDays'].errors['required']
                  ">
                      {{lang.Please_enter_reminder_email_days}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-12">
                  <button type="submit" [hidden]="licenseform.invalid" class="btn btn-primary">
                    {{lang.Save}}
                  </button>
                </div>
              </div>
            </form>
            <!-- lincenseInfo Table -->
            <div class="row">
              <div class="form-group col-12">
                <div style="direction: ltr; width: 100%">
                  <div class="row">
                    <div class="form-group col-12" style="margin-bottom: 3px">
                      <!-- <div style="overflow: auto; direction:ltr;  width: 100%;"> -->
                      <table align="left" *ngIf="addlicenseformtable">
                        <tr>
                          <th>{{lang.License}} #</th>
                          <th>{{lang.Coverage}}</th>
                          <th>{{lang.Province}}</th>
                          <th>{{lang.Expiry_Date}}</th>
                          <th>{{lang.Reminder_Days}}</th>
                          <th></th>
                        </tr>
                        <tbody>
                          <tr *ngFor="
                          let broker of addlicenseformData;
                          let i = index
                        " [ngClass]="{
                          orange: i % 2 == 0,
                          white: i % 2 != 0
                        }">
                            <td>
                              <input type="text" class="form-control checking-field" id="licenseNumber"
                                [(ngModel)]="broker.licenseNo" [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            " />
                            </td>
                            <td>
                              <select class="form-control" id="licenseCoverage" placeholder="Select"
                                [(ngModel)]="broker.licenseCoverage" [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            ">
                                <option value="" disabled>Select</option>

                                <option *ngFor="let name of licenseCoverageList" [value]="name.label">
                                  {{ name.display }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <select class="form-control" id="province" placeholder="Select"
                                (change)="insuranceprovincelist($event)" [(ngModel)]="broker.provinceshortName"
                                [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            ">
                                <option value="" disabled>Select</option>
                                <option *ngFor="let name of configprovinceres" [value]="name.shortName">
                                  {{ name.shortName }}
                                </option>
                              </select>
                            </td>
                            <td>
                              <input type="text" placeholder="Expiry Date" class="form-control" [min]="minDate"
                                [(ngModel)]="broker.expiryDate" [ngModelOptions]="{ standalone: true }" [disabled]="
                              isEditable || enableEditIndex != i
                            " bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                            </td>
                            <td>
                              <input type="text" class="form-control checking-field" id="remainder_days"
                                placeholder="Reminder Days" (keypress)="numberOnly($event)"
                                [(ngModel)]="broker.reminderMailDays" [ngModelOptions]="{ standalone: true }"
                                style="text-transform: capitalize" [disabled]="
                              isEditable || enableEditIndex != i
                            " />
                            </td>
                            <td style="display: flex; margin-top: 10px">
                              <button class="btn btn-default editpencil" data-bs-toggle="modal"
                                data-bs-target="#basicModaleditShared" (click)="
                              editadvisorlicenseDetailsShared($event, i, broker)
                            " *ngIf="enableEditIndex != i">
                                <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                                class="btn btn-default deleteicon" (click)="deletelicense(broker, i)"
                                *ngIf="enableEditIndex != i">
                                <i class="bi bi-trash-fill"></i>
                              </button>

                              <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaledit" (click)="editadvisorlicenseDetails($event, i,broker)" *ngIf="enableEditIndex != i">Edit</button>&nbsp;
                        <button class="brokertablestatus" style="color:red" (click)="deletelicense(broker,i)" *ngIf="enableEditIndex != i">Delete</button> -->
                              <button class="brokertablestatus" style="color: green"
                                *ngIf="!isEditable && enableEditIndex == i" (click)="saveLicense(broker, i)">
                                {{lang.Save}}</button>&nbsp;
                              <button class="brokertablestatus" style="color: red"
                                *ngIf="!isEditable && enableEditIndex == i" (click)="cancellicneseEdit($event, i)">
                                {{lang.Cancel}}
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <!-- <button *ngIf="addlicenseformtable"  class="btn btn-primary addgroupadmininfo" type="button"  data-bs-toggle="modal" data-bs-target="#basicModal1" (click)="hidegrpadmindetails()" >{{lang.Add_More}}</button> -->

                      <!-- </div> -->
                    </div>
                  </div>

                  <button *ngIf="addlicenseformtable" class="btn btn-primary addgroupadmininfo" type="button"
                    data-bs-toggle="modal" data-bs-target="#basicModal1Shared" (click)="addnewlicenseShared()">
                    {{lang.Add_More}}
                  </button>
                </div>
              </div>
            </div>

            <!-- {{lang.E_O_Information}} -->
            <div class="row pt-2">
              <div class="form-group col-12">
                <h6 class="admintitle">
                  {{lang.E_O_Information}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </h6>
              </div>
            </div>

            <form class="onbordingform" [formGroup]="eoform" (ngSubmit)="addEOformDetails()" *ngIf="addEOform">
              <div class="input-wrapper row">
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Insurer_Name}}</label>
                  <input type="text" class="form-control checking-field" id="insurerName" placeholder={{lang.Insurer_Name}}
                    formControlName="insurerName" style="text-transform: capitalize" />
                  <div *ngIf="
                  eo['insurerName'].touched && eo['insurerName'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['required']
                  ">
                      {{lang.Please_enter_Insurance_name}}
                    </div>
                    <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['minlength']
                  ">
                      {{lang.Insurer_name_must_be_atleast_3_characters}}
                    </div>
                    <div *ngIf="
                    eo['insurerName'].errors &&
                    eo['insurerName'].errors['maxlength']
                  ">
                      {{lang.Insurer_name_must_not_exceed_100_characters}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Certificate}} #</label>
                  <input type="text" class="form-control checking-field" id="certificateNumber"
                    placeholder={{lang.Certificate}} formControlName="certificateNo" />

                  <div *ngIf="
                  eo['certificateNo'].touched &&
                  eo['certificateNo'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    eo['certificateNo'].errors &&
                    eo['certificateNo'].errors['required']
                  ">
                      {{lang.Please_select_Certificate_Name}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Policy}} #</label>

                  <input type="text" class="form-control checking-field" id="PolicyNumber" placeholder={{lang.Policy}}
                    formControlName="policyNo" />

                  <div *ngIf="eo['policyNo'].touched && eo['policyNo'].invalid" class="help-block text-danger">
                    <div *ngIf="
                    eo['policyNo'].errors && eo['policyNo'].errors['required']
                  ">
                      {{lang.Please_enter_Policy_Number}}
                    </div>
                  </div>
                </div>
              </div>
              <div class="input-wrapper row">
                <div class="form-group col-md-4">
                  <label for="Corporation" class="Corporation">{{lang.Expiry_Date}}</label>

                  <input type="text" placeholder={{lang.Expiry_Date}} class="form-control" formControlName="expiryDate"
                    (onShown)="disableScrolling()" (onHidden)="enableScrolling()" [placement]='"top"'
                    [minDate]="todayDate" bsDatepicker [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}" />
                  <div *ngIf="
                  eo['expiryDate'].touched &&
                  eo['expiryDate'].invalid
                " class="help-block text-danger">
                    <div *ngIf="
                    eo['expiryDate'].errors &&
                    eo['expiryDate'].errors['required']
                  ">
                      {{lang.Please_select_expiry_date}}
                    </div>
                  </div>
                </div>
                <div class="form-group col-md-4"></div>
                <div class="form-group col-12">
                  <button type="submit" [hidden]="eoform.invalid" class="btn btn-primary">
                    {{lang.Save}}
                  </button>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div style="overflow: auto; direction: ltr; width: 100%">
                    <table align="left" *ngIf="showaddEOdetails">
                      <tr>
                        <th>{{lang.Insurer_Name}}</th>
                        <th>{{lang.Certificate}} #</th>
                        <th>{{lang.Policy}} #</th>
                        <th>{{lang.Expiry_Date}}</th>
                        <th></th>
                      </tr>
                      <tbody>
                        <tr>
                          <td>{{ EOinsurenceInfo.insurerName }}</td>
                          <td>
                            {{ EOinsurenceInfo.certificateNo | titlecase }}
                          </td>
                          <td>{{ EOinsurenceInfo.policyNo }}</td>
                          <td>
                            {{
                            EOinsurenceInfo.expiryDate
                            | date: 'MMM dd, yyyy'
                            }}
                          </td>
                          <td style="text-align: right; display: flex">
                            <button class="btn btn-default editpencil" data-bs-toggle="modal"
                              data-bs-target="#basicModaleoeditShared" (click)="editEOShared()">
                              <i class="bi bi-pencil-fill"></i></button>&nbsp;&nbsp;<button
                              class="btn btn-default deleteicon" (click)="deleteEO()">
                              <i class="bi bi-trash-fill"></i>
                            </button>

                            <!-- <button class="brokertablestatus"    data-bs-toggle="modal" data-bs-target="#basicModaleoedit"(click)="editEO()">Edit</button>&nbsp;
                  <button class="brokertablestatus" style="color:red" (click)="deleteEO()">Delete</button> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <!-- <button *ngIf="showaddadmin"  class="btn btn-primary addgroupadmininfo" type="button"  data-bs-toggle="modal" data-bs-target="#basicModaladdgrpcontact" (click)="hidegrpadmindetails()" >{{lang.Add_More}}</button> -->
              </div>
            </div>
            <br>
            <div *ngIf="showSharedAdvisorData" style="display: flex;justify-content: flex-end;">
              <button class="btn btn-primary" type="button" (click)="submitSharedNew()">
                {{lang.Submit}}
              </button>&nbsp;
              <!-- <button class="btn btn-primary addgroupadmininfo" type="button" (click)="addRow()">
            {{lang.Add_More}}
          </button> -->





            </div>



          </div>
          <div *ngIf="!showSharedAdvisorData">
            <div class="input-wrapper row" *ngIf="allBrokers && allBrokers.length > 0">
              <div class="form-group col-md-6">
                <label for="Corporation" class="Corporation">{{lang.Existing_Broker_Advisor}}</label>

                <!-- <select class="form-control select2" id="parentidrole" placeholder="Select"
                  formControlName="ParentbrokerName" [(ngModel)]="getsharedexisting" data-live-search="true"
                  (change)="getBrokerSharedExisting($event)">
                  <option value="" label="">Select</option>
                  <option *ngFor="let broker of allBrokersUnique" [ngValue]="broker">
                    {{ broker.name }}<span *ngIf="broker.description">-({{ broker.description }})</span>
                  </option>
                </select> -->

                <ng-multiselect-dropdown #multiSelectDropdown formControlName="ParentbrokerName"
                  placeholder={{lang.Select}} [settings]="dropdownSettings1" [data]="allBrokersUnique"
                  (onSelect)="multiSelectAdvsiorSelect($event)" (onSelectAll)="multiSelectAdvisorSelectAll($event)"
                  (onDeSelect)="multiSelectAdvisorItemDeSelect($event)" (onDeSelectAll)="
                  multiSelectAdvisorDeSelectAll($event)
                ">
                </ng-multiselect-dropdown>
                <!-- <div *ngIf="client['corporationName'].touched && client['corporationName'].invalid" class="help-block text-danger">
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['required']">Please enter corporation name</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['minlength']">Corporation name should be 3 character</div>
            <div *ngIf="client['corporationName'].errors && client['corporationName'].errors['maxlength']">Corporation name must not exceed 30 characters</div>
          </div> -->
              </div>
              <div class="form-group col-md-2" *ngIf="showsharedExistingButton">
                <button class="btn btn-primary addgroupadmininfoShared" type="button"
                  (click)="closeBrokerDetailsModel()">
                  {{lang.Submit}}
                </button>
              </div>

            </div>
          </div>
          <!-- <div *ngIf="!showSharedAdvisorData" style="display: flex;justify-content: flex-end;">
  <button class="btn btn-primary" type="button" (click)="submitSharedExisting()">
    Submit
  </button>&nbsp;







</div> -->
        </form>

      </div>


    </div>
  </div>
</div>
<!-- <footer id="footer" class="footer">
          <div class="copyright">Version IB:3.0.1 © 2024:
            <a class="text-reset fw-bold" href="https://www.groupbenefitz.ca/" target="-blank"> The GroupBenefitz Platform Inc.</a></div>
       </footer>
       <a (click)="scrollTop()" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a> -->
